/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './contentful-schema-types';

import { type GraphQLClient, type RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export * from "./contentful-schema-types";
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
export type AssetFragment = { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type BasicPageFragment = { __typename: 'BasicPage', title: string | null, slug: string | null, metaDescription: string | null, metaKeywords: Array<string | null> | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, copy: { json: unknown, links: { entries: { hyperlink: Array<
          | { __typename: 'BasicPage', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockBlogPosts', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockClassy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockCollapsible', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockCta', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockCustomComponent', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockDonate', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockElfsightWidget', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockEmailCollection', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockFormAssembly', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockFundraiseUp', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockHighlight', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockImages', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockImpactStatistics', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockPartners', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockPeople', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockPrograms', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockQuotation', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockQuotations', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockShare', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockTabs', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockThermometer', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockVideo', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlogCategory', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Bulletin', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BulletinBoard', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'DonationAppeal', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'EmbedInstagram', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'EmbedTwitter', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Hero', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Hospital', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'KnowledgeBasedResource', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'LayoutCopy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationDropdown', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationLink', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationPrimary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationSecondary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Partner', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Person', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'PressRelease', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Redirect', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Statistic', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Tab', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
         | null> } } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBasicPageBySlugQueryVariables = Exact<{
  slug?: string | null | undefined;
  preview?: boolean | null | undefined;
}>;


export type GetBasicPageBySlugQuery = { basicPageCollection: { items: Array<{ __typename: 'BasicPage', title: string | null, slug: string | null, metaDescription: string | null, metaKeywords: Array<string | null> | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, copy: { json: unknown, links: { entries: { hyperlink: Array<
              | { __typename: 'BasicPage', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockBlogPosts', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockClassy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockCollapsible', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockCta', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockCustomComponent', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockDonate', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockElfsightWidget', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockEmailCollection', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockFormAssembly', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockFundraiseUp', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockHighlight', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockImages', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockImpactStatistics', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockPartners', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockPeople', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockPrograms', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockQuotation', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockQuotations', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockShare', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockTabs', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockThermometer', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockVideo', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlogCategory', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Bulletin', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BulletinBoard', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'DonationAppeal', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'EmbedInstagram', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'EmbedTwitter', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Hero', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Hospital', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'KnowledgeBasedResource', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'LayoutCopy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'NavigationDropdown', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'NavigationLink', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'NavigationPrimary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'NavigationSecondary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Partner', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Person', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'PressRelease', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Redirect', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Statistic', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Tab', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
             | null> } } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type GetBasicPageSlugByIdQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBasicPageSlugByIdQuery = { basicPage: { slug: string | null } | null };

export type GetBasicPageSlugsQueryVariables = Exact<{
  limit?: number | null | undefined;
  skip?: number | null | undefined;
}>;


export type GetBasicPageSlugsQuery = { basicPageCollection: { total: number, items: Array<{ __typename: 'BasicPage', title: string | null, slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type BlockBlogPostsFragment = { __typename: 'BlockBlogPosts', headline: string | null, blogPostsCollection: { items: Array<{ __typename: 'BlogPost', title: string | null, slug: string | null, date: string | null, summary: string | null, metaDescription: string | null, metaKeywords: Array<string | null> | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, categories: { items: Array<{ title: string | null, color: unknown, sys: { id: string }, icon: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockBlogPostsQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockBlogPostsQuery = { blockBlogPosts: { __typename: 'BlockBlogPosts', headline: string | null, blogPostsCollection: { items: Array<{ __typename: 'BlogPost', title: string | null, slug: string | null, date: string | null, summary: string | null, metaDescription: string | null, metaKeywords: Array<string | null> | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, categories: { items: Array<{ title: string | null, color: unknown, sys: { id: string }, icon: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type BulletinItemFragment = { __typename: 'Bulletin', imageCaption: string | null, icon: string | null, copy: string | null, title: string | null, ctaTitle: string | null, ctaLink: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
      | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'PressRelease', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
     | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type BlockBulletinBoardFragment = { __typename: 'BulletinBoard', icon: string | null, headline: string | null, ctaHeadline: string | null, ctaTitle: string | null, ctaLink: string | null, visualStyle: string | null, separator: string | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
      | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
     | null> } | null, bulletinsCollection: { items: Array<{ __typename: 'Bulletin', imageCaption: string | null, icon: string | null, copy: string | null, title: string | null, ctaTitle: string | null, ctaLink: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
          | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'PressRelease', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
         | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockBulletinBoardQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockBulletinBoardQuery = { bulletinBoard: { __typename: 'BulletinBoard', icon: string | null, headline: string | null, ctaHeadline: string | null, ctaTitle: string | null, ctaLink: string | null, visualStyle: string | null, separator: string | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
        | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
       | null> } | null, bulletinsCollection: { items: Array<{ __typename: 'Bulletin', imageCaption: string | null, icon: string | null, copy: string | null, title: string | null, ctaTitle: string | null, ctaLink: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
            | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'PressRelease', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
           | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type GetBlockBulletinBoardIdsByBulletinIdQueryVariables = Exact<{
  id: string;
}>;


export type GetBlockBulletinBoardIdsByBulletinIdQuery = { bulletin: { linkedFrom: { bulletinBoardCollection: { items: Array<{ sys: { id: string } } | null> } | null } | null } | null };

export type BlockClassyFragment = { __typename: 'BlockClassy', headline: string | null, campaignId: string | null, recurringNudges: boolean | null, size: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockClassyQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockClassyQuery = { blockClassy: { __typename: 'BlockClassy', headline: string | null, campaignId: string | null, recurringNudges: boolean | null, size: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type BlockCollapsibleFragment = { __typename: 'BlockCollapsible', ctaTitle: string | null, block:
    | { __typename: 'BlockClassy', sys: { id: string } }
    | { __typename: 'BlockCustomComponent', sys: { id: string } }
    | { __typename: 'BlockDonate', sys: { id: string } }
    | { __typename: 'BlockElfsightWidget', sys: { id: string } }
    | { __typename: 'BlockEmailCollection', sys: { id: string } }
    | { __typename: 'BlockFormAssembly', sys: { id: string } }
    | { __typename: 'BlockFundraiseUp', sys: { id: string } }
    | { __typename: 'BlockImages', sys: { id: string } }
    | { __typename: 'BlockImpactStatistics', sys: { id: string } }
    | { __typename: 'BlockPeople', sys: { id: string } }
    | { __typename: 'BlockPrograms', sys: { id: string } }
    | { __typename: 'BlockQuotation', sys: { id: string } }
    | { __typename: 'BlockShare', sys: { id: string } }
    | { __typename: 'BlockThermometer', sys: { id: string } }
    | { __typename: 'BlockVideo', sys: { id: string } }
    | { __typename: 'BulletinBoard', sys: { id: string } }
    | { __typename: 'Hero', sys: { id: string } }
    | { __typename: 'LayoutCopy', sys: { id: string } }
   | null, collapsedBlock:
    | { __typename: 'BlockClassy', sys: { id: string } }
    | { __typename: 'BlockCustomComponent', sys: { id: string } }
    | { __typename: 'BlockDonate', sys: { id: string } }
    | { __typename: 'BlockElfsightWidget', sys: { id: string } }
    | { __typename: 'BlockEmailCollection', sys: { id: string } }
    | { __typename: 'BlockFormAssembly', sys: { id: string } }
    | { __typename: 'BlockFundraiseUp', sys: { id: string } }
    | { __typename: 'BlockImages', sys: { id: string } }
    | { __typename: 'BlockImpactStatistics', sys: { id: string } }
    | { __typename: 'BlockPeople', sys: { id: string } }
    | { __typename: 'BlockPrograms', sys: { id: string } }
    | { __typename: 'BlockQuotation', sys: { id: string } }
    | { __typename: 'BlockShare', sys: { id: string } }
    | { __typename: 'BlockThermometer', sys: { id: string } }
    | { __typename: 'BlockVideo', sys: { id: string } }
    | { __typename: 'BulletinBoard', sys: { id: string } }
    | { __typename: 'LayoutCopy', sys: { id: string } }
   | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockCollapsibleQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockCollapsibleQuery = { blockCollapsible: { __typename: 'BlockCollapsible', ctaTitle: string | null, block:
      | { __typename: 'BlockClassy', sys: { id: string } }
      | { __typename: 'BlockCustomComponent', sys: { id: string } }
      | { __typename: 'BlockDonate', sys: { id: string } }
      | { __typename: 'BlockElfsightWidget', sys: { id: string } }
      | { __typename: 'BlockEmailCollection', sys: { id: string } }
      | { __typename: 'BlockFormAssembly', sys: { id: string } }
      | { __typename: 'BlockFundraiseUp', sys: { id: string } }
      | { __typename: 'BlockImages', sys: { id: string } }
      | { __typename: 'BlockImpactStatistics', sys: { id: string } }
      | { __typename: 'BlockPeople', sys: { id: string } }
      | { __typename: 'BlockPrograms', sys: { id: string } }
      | { __typename: 'BlockQuotation', sys: { id: string } }
      | { __typename: 'BlockShare', sys: { id: string } }
      | { __typename: 'BlockThermometer', sys: { id: string } }
      | { __typename: 'BlockVideo', sys: { id: string } }
      | { __typename: 'BulletinBoard', sys: { id: string } }
      | { __typename: 'Hero', sys: { id: string } }
      | { __typename: 'LayoutCopy', sys: { id: string } }
     | null, collapsedBlock:
      | { __typename: 'BlockClassy', sys: { id: string } }
      | { __typename: 'BlockCustomComponent', sys: { id: string } }
      | { __typename: 'BlockDonate', sys: { id: string } }
      | { __typename: 'BlockElfsightWidget', sys: { id: string } }
      | { __typename: 'BlockEmailCollection', sys: { id: string } }
      | { __typename: 'BlockFormAssembly', sys: { id: string } }
      | { __typename: 'BlockFundraiseUp', sys: { id: string } }
      | { __typename: 'BlockImages', sys: { id: string } }
      | { __typename: 'BlockImpactStatistics', sys: { id: string } }
      | { __typename: 'BlockPeople', sys: { id: string } }
      | { __typename: 'BlockPrograms', sys: { id: string } }
      | { __typename: 'BlockQuotation', sys: { id: string } }
      | { __typename: 'BlockShare', sys: { id: string } }
      | { __typename: 'BlockThermometer', sys: { id: string } }
      | { __typename: 'BlockVideo', sys: { id: string } }
      | { __typename: 'BulletinBoard', sys: { id: string } }
      | { __typename: 'LayoutCopy', sys: { id: string } }
     | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type BlockCopyFragment = { __typename: 'LayoutCopy', icon: string | null, headline: string | null, ctaHeadline: string | null, ctaTitle: string | null, ctaLink: string | null, visualStyle: string | null, dropCap: boolean | null, separator: string | null, text: { json: unknown, links: { entries: { block: Array<
          | { __typename: 'BasicPage' }
          | { __typename: 'BlockBlogPosts' }
          | { __typename: 'BlockClassy' }
          | { __typename: 'BlockCollapsible' }
          | { __typename: 'BlockCta' }
          | { __typename: 'BlockCustomComponent' }
          | { __typename: 'BlockDonate' }
          | { __typename: 'BlockElfsightWidget' }
          | { __typename: 'BlockEmailCollection' }
          | { __typename: 'BlockFormAssembly' }
          | { __typename: 'BlockFundraiseUp' }
          | { __typename: 'BlockHighlight' }
          | { __typename: 'BlockImages' }
          | { __typename: 'BlockImpactStatistics' }
          | { __typename: 'BlockPartners' }
          | { __typename: 'BlockPeople' }
          | { __typename: 'BlockPrograms' }
          | { __typename: 'BlockQuotation' }
          | { __typename: 'BlockQuotations' }
          | { __typename: 'BlockShare' }
          | { __typename: 'BlockTabs' }
          | { __typename: 'BlockThermometer' }
          | { __typename: 'BlockVideo' }
          | { __typename: 'BlogCategory' }
          | { __typename: 'BlogPost' }
          | { __typename: 'Bulletin' }
          | { __typename: 'BulletinBoard' }
          | { __typename: 'DonationAppeal' }
          | { __typename: 'EmbedInstagram', title: string | null, url: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'EmbedTwitter', title: string | null, url: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Hero' }
          | { __typename: 'Hospital' }
          | { __typename: 'KnowledgeBasedResource' }
          | { __typename: 'LayoutCopy' }
          | { __typename: 'NavigationDropdown' }
          | { __typename: 'NavigationLink' }
          | { __typename: 'NavigationPrimary' }
          | { __typename: 'NavigationSecondary' }
          | { __typename: 'Page' }
          | { __typename: 'Partner' }
          | { __typename: 'Person' }
          | { __typename: 'PressRelease' }
          | { __typename: 'Program' }
          | { __typename: 'Redirect' }
          | { __typename: 'Statistic' }
          | { __typename: 'Tab' }
         | null>, hyperlink: Array<
          | { __typename: 'BasicPage', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockBlogPosts', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockClassy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockCollapsible', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockCta', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockCustomComponent', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockDonate', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockElfsightWidget', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockEmailCollection', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockFormAssembly', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockFundraiseUp', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockHighlight', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockImages', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockImpactStatistics', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockPartners', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockPeople', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockPrograms', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockQuotation', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockQuotations', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockShare', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockTabs', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockThermometer', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockVideo', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlogCategory', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Bulletin', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BulletinBoard', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'DonationAppeal', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'EmbedInstagram', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'EmbedTwitter', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Hero', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Hospital', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'KnowledgeBasedResource', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'LayoutCopy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationDropdown', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationLink', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationPrimary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationSecondary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Partner', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Person', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'PressRelease', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Redirect', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Statistic', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Tab', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
         | null> }, assets: { block: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null>, hyperlink: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } } } | null, ctaLinkContentCollection: { items: Array<
      | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
     | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockCopyQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockCopyQuery = { layoutCopy: { __typename: 'LayoutCopy', icon: string | null, headline: string | null, ctaHeadline: string | null, ctaTitle: string | null, ctaLink: string | null, visualStyle: string | null, dropCap: boolean | null, separator: string | null, text: { json: unknown, links: { entries: { block: Array<
            | { __typename: 'BasicPage' }
            | { __typename: 'BlockBlogPosts' }
            | { __typename: 'BlockClassy' }
            | { __typename: 'BlockCollapsible' }
            | { __typename: 'BlockCta' }
            | { __typename: 'BlockCustomComponent' }
            | { __typename: 'BlockDonate' }
            | { __typename: 'BlockElfsightWidget' }
            | { __typename: 'BlockEmailCollection' }
            | { __typename: 'BlockFormAssembly' }
            | { __typename: 'BlockFundraiseUp' }
            | { __typename: 'BlockHighlight' }
            | { __typename: 'BlockImages' }
            | { __typename: 'BlockImpactStatistics' }
            | { __typename: 'BlockPartners' }
            | { __typename: 'BlockPeople' }
            | { __typename: 'BlockPrograms' }
            | { __typename: 'BlockQuotation' }
            | { __typename: 'BlockQuotations' }
            | { __typename: 'BlockShare' }
            | { __typename: 'BlockTabs' }
            | { __typename: 'BlockThermometer' }
            | { __typename: 'BlockVideo' }
            | { __typename: 'BlogCategory' }
            | { __typename: 'BlogPost' }
            | { __typename: 'Bulletin' }
            | { __typename: 'BulletinBoard' }
            | { __typename: 'DonationAppeal' }
            | { __typename: 'EmbedInstagram', title: string | null, url: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'EmbedTwitter', title: string | null, url: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Hero' }
            | { __typename: 'Hospital' }
            | { __typename: 'KnowledgeBasedResource' }
            | { __typename: 'LayoutCopy' }
            | { __typename: 'NavigationDropdown' }
            | { __typename: 'NavigationLink' }
            | { __typename: 'NavigationPrimary' }
            | { __typename: 'NavigationSecondary' }
            | { __typename: 'Page' }
            | { __typename: 'Partner' }
            | { __typename: 'Person' }
            | { __typename: 'PressRelease' }
            | { __typename: 'Program' }
            | { __typename: 'Redirect' }
            | { __typename: 'Statistic' }
            | { __typename: 'Tab' }
           | null>, hyperlink: Array<
            | { __typename: 'BasicPage', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockBlogPosts', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockClassy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockCollapsible', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockCta', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockCustomComponent', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockDonate', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockElfsightWidget', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockEmailCollection', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockFormAssembly', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockFundraiseUp', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockHighlight', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockImages', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockImpactStatistics', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockPartners', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockPeople', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockPrograms', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockQuotation', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockQuotations', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockShare', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockTabs', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockThermometer', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockVideo', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlogCategory', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Bulletin', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BulletinBoard', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'DonationAppeal', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'EmbedInstagram', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'EmbedTwitter', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Hero', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Hospital', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'KnowledgeBasedResource', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'LayoutCopy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'NavigationDropdown', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'NavigationLink', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'NavigationPrimary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'NavigationSecondary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Partner', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Person', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'PressRelease', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Redirect', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Statistic', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Tab', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
           | null> }, assets: { block: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null>, hyperlink: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } } } | null, ctaLinkContentCollection: { items: Array<
        | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
       | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type BlockCtaFragment = { __typename: 'BlockCta', headline: string | null, ctaTitle: string | null, ctaLink: string | null, variant: string | null, copy: { json: unknown, links: { entries: { hyperlink: Array<
          | { __typename: 'BasicPage', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockBlogPosts', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockClassy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockCollapsible', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockCta', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockCustomComponent', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockDonate', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockElfsightWidget', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockEmailCollection', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockFormAssembly', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockFundraiseUp', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockHighlight', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockImages', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockImpactStatistics', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockPartners', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockPeople', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockPrograms', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockQuotation', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockQuotations', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockShare', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockTabs', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockThermometer', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockVideo', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlogCategory', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Bulletin', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BulletinBoard', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'DonationAppeal', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'EmbedInstagram', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'EmbedTwitter', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Hero', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Hospital', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'KnowledgeBasedResource', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'LayoutCopy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationDropdown', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationLink', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationPrimary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationSecondary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Partner', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Person', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'PressRelease', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Redirect', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Statistic', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Tab', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
         | null> }, assets: { block: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null>, hyperlink: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } } } | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
      | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
     | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockCtaQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockCtaQuery = { blockCta: { __typename: 'BlockCta', headline: string | null, ctaTitle: string | null, ctaLink: string | null, variant: string | null, copy: { json: unknown, links: { entries: { hyperlink: Array<
            | { __typename: 'BasicPage', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockBlogPosts', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockClassy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockCollapsible', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockCta', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockCustomComponent', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockDonate', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockElfsightWidget', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockEmailCollection', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockFormAssembly', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockFundraiseUp', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockHighlight', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockImages', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockImpactStatistics', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockPartners', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockPeople', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockPrograms', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockQuotation', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockQuotations', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockShare', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockTabs', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockThermometer', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockVideo', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlogCategory', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Bulletin', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BulletinBoard', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'DonationAppeal', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'EmbedInstagram', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'EmbedTwitter', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Hero', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Hospital', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'KnowledgeBasedResource', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'LayoutCopy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'NavigationDropdown', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'NavigationLink', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'NavigationPrimary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'NavigationSecondary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Partner', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Person', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'PressRelease', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Redirect', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Statistic', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Tab', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
           | null> }, assets: { block: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null>, hyperlink: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } } } | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
        | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
       | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type BlockCustomComponentFragment = { __typename: 'BlockCustomComponent', componentName: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockCustomComponentQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockCustomComponentQuery = { blockCustomComponent: { __typename: 'BlockCustomComponent', componentName: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type DonateAppealItemFragment = { __typename: 'DonationAppeal', icon: string | null, headline: string | null, copy: string | null, imageCaption: string | null, ctaTitle: string | null, ctaLink: string | null, moreLink: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
      | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
     | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, moreLinkContentCollection: { items: Array<
      | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
     | null> } | null, moreLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type BlockDonateFragment = { __typename: 'BlockDonate', icon: string | null, headline: string | null, separator: string | null, donationAppealsCollection: { items: Array<{ __typename: 'DonationAppeal', icon: string | null, headline: string | null, copy: string | null, imageCaption: string | null, ctaTitle: string | null, ctaLink: string | null, moreLink: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
          | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
         | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, moreLinkContentCollection: { items: Array<
          | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
         | null> } | null, moreLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockDonateQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockDonateQuery = { blockDonate: { __typename: 'BlockDonate', icon: string | null, headline: string | null, separator: string | null, donationAppealsCollection: { items: Array<{ __typename: 'DonationAppeal', icon: string | null, headline: string | null, copy: string | null, imageCaption: string | null, ctaTitle: string | null, ctaLink: string | null, moreLink: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
            | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
           | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, moreLinkContentCollection: { items: Array<
            | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
           | null> } | null, moreLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type GetBlockDonateIdsByDonationAppealIdQueryVariables = Exact<{
  id: string;
}>;


export type GetBlockDonateIdsByDonationAppealIdQuery = { donationAppeal: { linkedFrom: { blockDonateCollection: { items: Array<{ sys: { id: string } } | null> } | null } | null } | null };

export type BlockElfsightWidgetFragment = { __typename: 'BlockElfsightWidget', headline: string | null, icon: string | null, appId: string | null, separator: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockElfsightCalendarQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockElfsightCalendarQuery = { blockElfsightWidget: { __typename: 'BlockElfsightWidget', headline: string | null, icon: string | null, appId: string | null, separator: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type BlockEmailCollectionFragment = { __typename: 'BlockEmailCollection', heading: string | null, copy: string | null, icon: string | null, ctaTitle: string | null, formId: string | null, separator: string | null, urlEndpoint: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockEmailCollectionQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockEmailCollectionQuery = { blockEmailCollection: { __typename: 'BlockEmailCollection', heading: string | null, copy: string | null, icon: string | null, ctaTitle: string | null, formId: string | null, separator: string | null, urlEndpoint: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type BlockFormAssemblyFragment = { __typename: 'BlockFormAssembly', html: string | null, separator: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockFormAssemblyQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockFormAssemblyQuery = { blockFormAssembly: { __typename: 'BlockFormAssembly', html: string | null, separator: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type BlockFundraiseUpFragment = { __typename: 'BlockFundraiseUp', elementId: string | null, headline: string | null, widgetType: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockFundraiseUpQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockFundraiseUpQuery = { blockFundraiseUp: { __typename: 'BlockFundraiseUp', elementId: string | null, headline: string | null, widgetType: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type BlockHeroFragment = { __typename: 'Hero', kicker: string | null, headline: string | null, copy: string | null, ctaTitlePrimary: string | null, ctaLinkPrimary: string | null, ctaTitleSecondary: string | null, ctaLinkSecondary: string | null, ctaProminence: string | null, separator: string | null, aspectRatio: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, logo: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, videoAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentPrimaryCollection: { items: Array<
      | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
     | null> } | null, ctaLinkAssetPrimary: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentSecondaryCollection: { items: Array<
      | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
     | null> } | null, ctaLinkAssetSecondary: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockHeroQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockHeroQuery = { hero: { __typename: 'Hero', kicker: string | null, headline: string | null, copy: string | null, ctaTitlePrimary: string | null, ctaLinkPrimary: string | null, ctaTitleSecondary: string | null, ctaLinkSecondary: string | null, ctaProminence: string | null, separator: string | null, aspectRatio: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, logo: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, videoAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentPrimaryCollection: { items: Array<
        | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
       | null> } | null, ctaLinkAssetPrimary: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentSecondaryCollection: { items: Array<
        | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
       | null> } | null, ctaLinkAssetSecondary: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type BlockHighlightFragment = { __typename: 'BlockHighlight', headline: string | null, copy: string | null, imageCaption: string | null, ctaTitle: string | null, ctaLink: string | null, ctaVariant: string | null, decoration: string | null, aspectRatio: string | null, reversed: boolean | null, background: string | null, text: { json: unknown, links: { entries: { hyperlink: Array<
          | { __typename: 'BasicPage', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockBlogPosts', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockClassy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockCollapsible', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockCta', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockCustomComponent', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockDonate', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockElfsightWidget', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockEmailCollection', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockFormAssembly', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockFundraiseUp', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockHighlight', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockImages', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockImpactStatistics', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockPartners', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockPeople', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockPrograms', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockQuotation', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockQuotations', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockShare', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockTabs', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockThermometer', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockVideo', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlogCategory', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Bulletin', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BulletinBoard', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'DonationAppeal', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'EmbedInstagram', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'EmbedTwitter', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Hero', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Hospital', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'KnowledgeBasedResource', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'LayoutCopy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationDropdown', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationLink', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationPrimary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationSecondary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Partner', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Person', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'PressRelease', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Redirect', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Statistic', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Tab', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
         | null> }, assets: { block: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null>, hyperlink: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } } } | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
      | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
     | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, videoAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockHighlightQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockHighlightQuery = { blockHighlight: { __typename: 'BlockHighlight', headline: string | null, copy: string | null, imageCaption: string | null, ctaTitle: string | null, ctaLink: string | null, ctaVariant: string | null, decoration: string | null, aspectRatio: string | null, reversed: boolean | null, background: string | null, text: { json: unknown, links: { entries: { hyperlink: Array<
            | { __typename: 'BasicPage', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockBlogPosts', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockClassy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockCollapsible', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockCta', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockCustomComponent', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockDonate', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockElfsightWidget', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockEmailCollection', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockFormAssembly', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockFundraiseUp', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockHighlight', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockImages', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockImpactStatistics', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockPartners', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockPeople', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockPrograms', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockQuotation', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockQuotations', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockShare', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockTabs', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockThermometer', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlockVideo', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlogCategory', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Bulletin', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'BulletinBoard', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'DonationAppeal', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'EmbedInstagram', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'EmbedTwitter', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Hero', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Hospital', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'KnowledgeBasedResource', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'LayoutCopy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'NavigationDropdown', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'NavigationLink', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'NavigationPrimary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'NavigationSecondary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Partner', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Person', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'PressRelease', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Redirect', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Statistic', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Tab', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
           | null> }, assets: { block: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null>, hyperlink: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } } } | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
        | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
       | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, videoAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type BlockImagesFragment = { __typename: 'BlockImages', icon: string | null, headline: string | null, ctaHeadline: string | null, ctaTitle: string | null, ctaLink: string | null, separator: string | null, ctaLinkContentCollection: { items: Array<
      | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
     | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, imagesCollection: { items: Array<{ __typename: 'Asset', title: string | null, description: string | null, url: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockImagesQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockImagesQuery = { blockImages: { __typename: 'BlockImages', icon: string | null, headline: string | null, ctaHeadline: string | null, ctaTitle: string | null, ctaLink: string | null, separator: string | null, ctaLinkContentCollection: { items: Array<
        | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
       | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, imagesCollection: { items: Array<{ __typename: 'Asset', title: string | null, description: string | null, url: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type StatisticItemFragment = { __typename: 'Statistic', headline: string | null, copy: string | null, ctaHeadline: string | null, ctaTitle: string | null, ctaLink: string | null, statType: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
      | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
     | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type BlockStatisticsFragment = { __typename: 'BlockImpactStatistics', icon: string | null, headline: string | null, copy: string | null, ctaHeadline: string | null, ctaTitle: string | null, ctaLink: string | null, separator: string | null, statisticsCollection: { items: Array<{ __typename: 'Statistic', headline: string | null, copy: string | null, ctaHeadline: string | null, ctaTitle: string | null, ctaLink: string | null, statType: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
          | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
         | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
      | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
     | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockStatisticsQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockStatisticsQuery = { blockImpactStatistics: { __typename: 'BlockImpactStatistics', icon: string | null, headline: string | null, copy: string | null, ctaHeadline: string | null, ctaTitle: string | null, ctaLink: string | null, separator: string | null, statisticsCollection: { items: Array<{ __typename: 'Statistic', headline: string | null, copy: string | null, ctaHeadline: string | null, ctaTitle: string | null, ctaLink: string | null, statType: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
            | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
           | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
        | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
       | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type GetBlockImpactStatisticIdsByStatisticIdQueryVariables = Exact<{
  id: string;
}>;


export type GetBlockImpactStatisticIdsByStatisticIdQuery = { statistic: { linkedFrom: { blockImpactStatisticsCollection: { items: Array<{ sys: { id: string } } | null> } | null } | null } | null };

export type PartnerTeaserFragment = { __typename: 'Partner', title: string | null, slug: string | null, createPage: boolean | null, shortDescription: { json: unknown } | null, logo: { __typename: 'Asset', width: number | null, height: number | null, url: string | null, title: string | null, description: string | null, contentType: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, image: { __typename: 'Asset', width: number | null, height: number | null, url: string | null, title: string | null, description: string | null, contentType: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type BlockPartnersFragment = { __typename: 'BlockPartners', headline: string | null, ctaTitle: string | null, ctaLink: string | null, layout: string | null, partnersCollection: { items: Array<{ __typename: 'Partner', title: string | null, slug: string | null, createPage: boolean | null, shortDescription: { json: unknown } | null, logo: { __typename: 'Asset', width: number | null, height: number | null, url: string | null, title: string | null, description: string | null, contentType: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, image: { __typename: 'Asset', width: number | null, height: number | null, url: string | null, title: string | null, description: string | null, contentType: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, ctaLinkContentCollection: { items: Array<
      | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
     | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockPartnersQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockPartnersQuery = { blockPartners: { __typename: 'BlockPartners', headline: string | null, ctaTitle: string | null, ctaLink: string | null, layout: string | null, partnersCollection: { items: Array<{ __typename: 'Partner', title: string | null, slug: string | null, createPage: boolean | null, shortDescription: { json: unknown } | null, logo: { __typename: 'Asset', width: number | null, height: number | null, url: string | null, title: string | null, description: string | null, contentType: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, image: { __typename: 'Asset', width: number | null, height: number | null, url: string | null, title: string | null, description: string | null, contentType: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, ctaLinkContentCollection: { items: Array<
        | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
       | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type PersonItemFragment = { __typename: 'Person', fullName: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, emailAddress: string | null, shortBio: string | null, photo: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type BlockPeopleFragment = { __typename: 'BlockPeople', headline: string | null, icon: string | null, separator: string | null, peopleCollection: { items: Array<{ __typename: 'Person', fullName: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, emailAddress: string | null, shortBio: string | null, photo: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockPeopleQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockPeopleQuery = { blockPeople: { __typename: 'BlockPeople', headline: string | null, icon: string | null, separator: string | null, peopleCollection: { items: Array<{ __typename: 'Person', fullName: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, emailAddress: string | null, shortBio: string | null, photo: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type GetBlockPeopleIdsByPersonIdQueryVariables = Exact<{
  id: string;
}>;


export type GetBlockPeopleIdsByPersonIdQuery = { person: { linkedFrom: { blockPeopleCollection: { items: Array<{ sys: { id: string } } | null> } | null } | null } | null };

export type ProgramItemFragment = { __typename: 'Program', title: string | null, icon: string | null, slug: string | null, overview: string | null, donateLink: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type BlockProgramsFragment = { __typename: 'BlockPrograms', icon: string | null, headline: string | null, separator: string | null, programsCollection: { items: Array<{ __typename: 'Program', title: string | null, icon: string | null, slug: string | null, overview: string | null, donateLink: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockProgramsQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockProgramsQuery = { blockPrograms: { __typename: 'BlockPrograms', icon: string | null, headline: string | null, separator: string | null, programsCollection: { items: Array<{ __typename: 'Program', title: string | null, icon: string | null, slug: string | null, overview: string | null, donateLink: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type GetBlockProgramIdsByProgramIdQueryVariables = Exact<{
  id: string;
}>;


export type GetBlockProgramIdsByProgramIdQuery = { program: { linkedFrom: { blockProgramsCollection: { items: Array<{ sys: { id: string } } | null> } | null } | null } | null };

export type BlockQuotationFragment = { __typename: 'BlockQuotation', quote: string | null, attribution: string | null, ctaTitle: string | null, ctaLink: string | null, separator: string | null, variant: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
      | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
     | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockQuotationQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockQuotationQuery = { blockQuotation: { __typename: 'BlockQuotation', quote: string | null, attribution: string | null, ctaTitle: string | null, ctaLink: string | null, separator: string | null, variant: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
        | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
       | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type BlockQuotationsFragment = { __typename: 'BlockQuotations', variant: string | null, quotationsCollection: { items: Array<{ __typename: 'BlockQuotation', quote: string | null, attribution: string | null, ctaTitle: string | null, ctaLink: string | null, separator: string | null, variant: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
          | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
         | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockQuotationsQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockQuotationsQuery = { blockQuotations: { __typename: 'BlockQuotations', variant: string | null, quotationsCollection: { items: Array<{ __typename: 'BlockQuotation', quote: string | null, attribution: string | null, ctaTitle: string | null, ctaLink: string | null, separator: string | null, variant: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
            | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
           | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type BlockShareFragment = { __typename: 'BlockShare', icon: string | null, heading: string | null, copy: string | null, url: string | null, separator: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockShareQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockShareQuery = { blockShare: { __typename: 'BlockShare', icon: string | null, heading: string | null, copy: string | null, url: string | null, separator: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type TabItemFragment = { __typename: 'Tab', headline: string | null, ctaTitlePrimary: string | null, ctaLinkPrimary: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, copy: { json: unknown, links: { assets: { hyperlink: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } } } | null, ctaLinkContentPrimaryCollection: { items: Array<
      | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
     | null> } | null, ctaLinkAssetPrimary: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type BlockTabsFragment = { __typename: 'BlockTabs', tabsCollection: { items: Array<{ __typename: 'Tab', headline: string | null, ctaTitlePrimary: string | null, ctaLinkPrimary: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, copy: { json: unknown, links: { assets: { hyperlink: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } } } | null, ctaLinkContentPrimaryCollection: { items: Array<
          | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
         | null> } | null, ctaLinkAssetPrimary: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockTabsQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockTabsQuery = { blockTabs: { __typename: 'BlockTabs', tabsCollection: { items: Array<{ __typename: 'Tab', headline: string | null, ctaTitlePrimary: string | null, ctaLinkPrimary: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, copy: { json: unknown, links: { assets: { hyperlink: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } } } | null, ctaLinkContentPrimaryCollection: { items: Array<
            | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
           | null> } | null, ctaLinkAssetPrimary: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type GetBlockTabsIdsByTabIdQueryVariables = Exact<{
  id: string;
}>;


export type GetBlockTabsIdsByTabIdQuery = { tab: { linkedFrom: { blockTabsCollection: { items: Array<{ sys: { id: string } } | null> } | null } | null } | null };

export type BlockThermometerFragment = { __typename: 'BlockThermometer', title: string | null, milestones: Array<string | null> | null, amountRaised: number | null, amountGoal: number | null, confettiType: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockThermometerQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockThermometerQuery = { blockThermometer: { __typename: 'BlockThermometer', title: string | null, milestones: Array<string | null> | null, amountRaised: number | null, amountGoal: number | null, confettiType: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type BlockVideoFragment = { __typename: 'BlockVideo', icon: string | null, headline: string | null, autoplay: boolean | null, playerSize: string | null, videoUrl: string | null, description: string | null, ctaHeadline: string | null, ctaTitle: string | null, ctaLink: string | null, separator: string | null, thumbnail: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
      | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
     | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, videoAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetBlockVideoQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlockVideoQuery = { blockVideo: { __typename: 'BlockVideo', icon: string | null, headline: string | null, autoplay: boolean | null, playerSize: string | null, videoUrl: string | null, description: string | null, ctaHeadline: string | null, ctaTitle: string | null, ctaLink: string | null, separator: string | null, thumbnail: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, ctaLinkContentCollection: { items: Array<
        | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
       | null> } | null, ctaLinkAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, videoAsset: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type BlogTeaserFragment = { __typename: 'BlogPost', title: string | null, slug: string | null, date: string | null, summary: string | null, metaDescription: string | null, metaKeywords: Array<string | null> | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, categories: { items: Array<{ title: string | null, color: unknown, sys: { id: string }, icon: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type BlogPageFragment = { __typename: 'BlogPost', title: string | null, slug: string | null, date: string | null, metaDescription: string | null, metaKeywords: Array<string | null> | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, blocks: { total: number, skip: number, limit: number, items: Array<
      | { __typename: 'BlockClassy', sys: { id: string } }
      | { __typename: 'BlockCollapsible', sys: { id: string } }
      | { __typename: 'BlockDonate', sys: { id: string } }
      | { __typename: 'BlockEmailCollection', sys: { id: string } }
      | { __typename: 'BlockFundraiseUp', sys: { id: string } }
      | { __typename: 'BlockHighlight', sys: { id: string } }
      | { __typename: 'BlockImages', sys: { id: string } }
      | { __typename: 'BlockImpactStatistics', sys: { id: string } }
      | { __typename: 'BlockPeople', sys: { id: string } }
      | { __typename: 'BlockPrograms', sys: { id: string } }
      | { __typename: 'BlockQuotation', sys: { id: string } }
      | { __typename: 'BlockQuotations', sys: { id: string } }
      | { __typename: 'BlockTabs', sys: { id: string } }
      | { __typename: 'BlockVideo', sys: { id: string } }
      | { __typename: 'BulletinBoard', sys: { id: string } }
      | { __typename: 'LayoutCopy', sys: { id: string } }
     | null> } | null, closerBlocks: { total: number, skip: number, limit: number, items: Array<
      | { __typename: 'BlockBlogPosts', sys: { id: string } }
      | { __typename: 'BlockEmailCollection', sys: { id: string } }
      | { __typename: 'BlockHighlight', sys: { id: string } }
      | { __typename: 'BulletinBoard', sys: { id: string } }
     | null> } | null, authors: { items: Array<{ __typename: 'Person', fullName: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, emailAddress: string | null, shortBio: string | null, photo: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, categories: { items: Array<{ title: string | null, color: unknown, sys: { id: string }, icon: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type BlogCategoryFragment = { title: string | null, color: unknown, sys: { id: string }, icon: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type GetBlogSlugsQueryVariables = Exact<{
  limit?: number | null | undefined;
  skip?: number | null | undefined;
  where?: Types.BlogPostFilter | null | undefined;
  order?: Array<Types.BlogPostOrder | null | undefined> | Types.BlogPostOrder | null | undefined;
}>;


export type GetBlogSlugsQuery = { blogPostCollection: { total: number, items: Array<{ __typename: 'BlogPost', title: string | null, slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type GetBlogPostsQueryVariables = Exact<{
  where?: Types.BlogPostFilter | null | undefined;
  limit?: number | null | undefined;
  skip?: number | null | undefined;
  order?: Array<Types.BlogPostOrder | null | undefined> | Types.BlogPostOrder | null | undefined;
  preview?: boolean | null | undefined;
}>;


export type GetBlogPostsQuery = { blogs: { total: number, skip: number, limit: number, items: Array<{ __typename: 'BlogPost', title: string | null, slug: string | null, date: string | null, summary: string | null, metaDescription: string | null, metaKeywords: Array<string | null> | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, categories: { items: Array<{ title: string | null, color: unknown, sys: { id: string }, icon: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type SearchBlogPostsQueryVariables = Exact<{
  where?: Types.BlogPostFilter | null | undefined;
  limit?: number | null | undefined;
  skip?: number | null | undefined;
  order?: Array<Types.BlogPostOrder | null | undefined> | Types.BlogPostOrder | null | undefined;
  preview?: boolean | null | undefined;
}>;


export type SearchBlogPostsQuery = { blogs: { total: number, skip: number, limit: number, items: Array<{ __typename: 'BlogPost', title: string | null, slug: string | null, date: string | null, summary: string | null, metaDescription: string | null, metaKeywords: Array<string | null> | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, categories: { items: Array<{ title: string | null, color: unknown, sys: { id: string }, icon: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type GetBlogPostBySlugQueryVariables = Exact<{
  slug?: string | null | undefined;
  preview?: boolean | null | undefined;
}>;


export type GetBlogPostBySlugQuery = { blogPostCollection: { items: Array<{ __typename: 'BlogPost', title: string | null, slug: string | null, date: string | null, metaDescription: string | null, metaKeywords: Array<string | null> | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, blocks: { total: number, skip: number, limit: number, items: Array<
          | { __typename: 'BlockClassy', sys: { id: string } }
          | { __typename: 'BlockCollapsible', sys: { id: string } }
          | { __typename: 'BlockDonate', sys: { id: string } }
          | { __typename: 'BlockEmailCollection', sys: { id: string } }
          | { __typename: 'BlockFundraiseUp', sys: { id: string } }
          | { __typename: 'BlockHighlight', sys: { id: string } }
          | { __typename: 'BlockImages', sys: { id: string } }
          | { __typename: 'BlockImpactStatistics', sys: { id: string } }
          | { __typename: 'BlockPeople', sys: { id: string } }
          | { __typename: 'BlockPrograms', sys: { id: string } }
          | { __typename: 'BlockQuotation', sys: { id: string } }
          | { __typename: 'BlockQuotations', sys: { id: string } }
          | { __typename: 'BlockTabs', sys: { id: string } }
          | { __typename: 'BlockVideo', sys: { id: string } }
          | { __typename: 'BulletinBoard', sys: { id: string } }
          | { __typename: 'LayoutCopy', sys: { id: string } }
         | null> } | null, closerBlocks: { total: number, skip: number, limit: number, items: Array<
          | { __typename: 'BlockBlogPosts', sys: { id: string } }
          | { __typename: 'BlockEmailCollection', sys: { id: string } }
          | { __typename: 'BlockHighlight', sys: { id: string } }
          | { __typename: 'BulletinBoard', sys: { id: string } }
         | null> } | null, authors: { items: Array<{ __typename: 'Person', fullName: string | null, firstName: string | null, lastName: string | null, jobTitle: string | null, emailAddress: string | null, shortBio: string | null, photo: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, categories: { items: Array<{ title: string | null, color: unknown, sys: { id: string }, icon: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type GetBlogPostSlugByIdQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetBlogPostSlugByIdQuery = { blogPost: { slug: string | null } | null };

export type GetBlogPostSlugsQueryVariables = Exact<{
  limit?: number | null | undefined;
  skip?: number | null | undefined;
}>;


export type GetBlogPostSlugsQuery = { blogPostCollection: { total: number, items: Array<{ __typename: 'BlogPost', title: string | null, slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

type ContentBlock_BasicPage_Fragment = { __typename: 'BasicPage', sys: { id: string } };

type ContentBlock_BlockBlogPosts_Fragment = { __typename: 'BlockBlogPosts', sys: { id: string } };

type ContentBlock_BlockClassy_Fragment = { __typename: 'BlockClassy', sys: { id: string } };

type ContentBlock_BlockCollapsible_Fragment = { __typename: 'BlockCollapsible', sys: { id: string } };

type ContentBlock_BlockCta_Fragment = { __typename: 'BlockCta', sys: { id: string } };

type ContentBlock_BlockCustomComponent_Fragment = { __typename: 'BlockCustomComponent', sys: { id: string } };

type ContentBlock_BlockDonate_Fragment = { __typename: 'BlockDonate', sys: { id: string } };

type ContentBlock_BlockElfsightWidget_Fragment = { __typename: 'BlockElfsightWidget', sys: { id: string } };

type ContentBlock_BlockEmailCollection_Fragment = { __typename: 'BlockEmailCollection', sys: { id: string } };

type ContentBlock_BlockFormAssembly_Fragment = { __typename: 'BlockFormAssembly', sys: { id: string } };

type ContentBlock_BlockFundraiseUp_Fragment = { __typename: 'BlockFundraiseUp', sys: { id: string } };

type ContentBlock_BlockHighlight_Fragment = { __typename: 'BlockHighlight', sys: { id: string } };

type ContentBlock_BlockImages_Fragment = { __typename: 'BlockImages', sys: { id: string } };

type ContentBlock_BlockImpactStatistics_Fragment = { __typename: 'BlockImpactStatistics', sys: { id: string } };

type ContentBlock_BlockPartners_Fragment = { __typename: 'BlockPartners', sys: { id: string } };

type ContentBlock_BlockPeople_Fragment = { __typename: 'BlockPeople', sys: { id: string } };

type ContentBlock_BlockPrograms_Fragment = { __typename: 'BlockPrograms', sys: { id: string } };

type ContentBlock_BlockQuotation_Fragment = { __typename: 'BlockQuotation', sys: { id: string } };

type ContentBlock_BlockQuotations_Fragment = { __typename: 'BlockQuotations', sys: { id: string } };

type ContentBlock_BlockShare_Fragment = { __typename: 'BlockShare', sys: { id: string } };

type ContentBlock_BlockTabs_Fragment = { __typename: 'BlockTabs', sys: { id: string } };

type ContentBlock_BlockThermometer_Fragment = { __typename: 'BlockThermometer', sys: { id: string } };

type ContentBlock_BlockVideo_Fragment = { __typename: 'BlockVideo', sys: { id: string } };

type ContentBlock_BlogCategory_Fragment = { __typename: 'BlogCategory', sys: { id: string } };

type ContentBlock_BlogPost_Fragment = { __typename: 'BlogPost', sys: { id: string } };

type ContentBlock_Bulletin_Fragment = { __typename: 'Bulletin', sys: { id: string } };

type ContentBlock_BulletinBoard_Fragment = { __typename: 'BulletinBoard', sys: { id: string } };

type ContentBlock_DonationAppeal_Fragment = { __typename: 'DonationAppeal', sys: { id: string } };

type ContentBlock_EmbedInstagram_Fragment = { __typename: 'EmbedInstagram', sys: { id: string } };

type ContentBlock_EmbedTwitter_Fragment = { __typename: 'EmbedTwitter', sys: { id: string } };

type ContentBlock_Hero_Fragment = { __typename: 'Hero', sys: { id: string } };

type ContentBlock_Hospital_Fragment = { __typename: 'Hospital', sys: { id: string } };

type ContentBlock_KnowledgeBasedResource_Fragment = { __typename: 'KnowledgeBasedResource', sys: { id: string } };

type ContentBlock_LayoutCopy_Fragment = { __typename: 'LayoutCopy', sys: { id: string } };

type ContentBlock_NavigationDropdown_Fragment = { __typename: 'NavigationDropdown', sys: { id: string } };

type ContentBlock_NavigationLink_Fragment = { __typename: 'NavigationLink', sys: { id: string } };

type ContentBlock_NavigationPrimary_Fragment = { __typename: 'NavigationPrimary', sys: { id: string } };

type ContentBlock_NavigationSecondary_Fragment = { __typename: 'NavigationSecondary', sys: { id: string } };

type ContentBlock_Page_Fragment = { __typename: 'Page', sys: { id: string } };

type ContentBlock_Partner_Fragment = { __typename: 'Partner', sys: { id: string } };

type ContentBlock_Person_Fragment = { __typename: 'Person', sys: { id: string } };

type ContentBlock_PressRelease_Fragment = { __typename: 'PressRelease', sys: { id: string } };

type ContentBlock_Program_Fragment = { __typename: 'Program', sys: { id: string } };

type ContentBlock_Redirect_Fragment = { __typename: 'Redirect', sys: { id: string } };

type ContentBlock_Statistic_Fragment = { __typename: 'Statistic', sys: { id: string } };

type ContentBlock_Tab_Fragment = { __typename: 'Tab', sys: { id: string } };

export type ContentBlockFragment =
  | ContentBlock_BasicPage_Fragment
  | ContentBlock_BlockBlogPosts_Fragment
  | ContentBlock_BlockClassy_Fragment
  | ContentBlock_BlockCollapsible_Fragment
  | ContentBlock_BlockCta_Fragment
  | ContentBlock_BlockCustomComponent_Fragment
  | ContentBlock_BlockDonate_Fragment
  | ContentBlock_BlockElfsightWidget_Fragment
  | ContentBlock_BlockEmailCollection_Fragment
  | ContentBlock_BlockFormAssembly_Fragment
  | ContentBlock_BlockFundraiseUp_Fragment
  | ContentBlock_BlockHighlight_Fragment
  | ContentBlock_BlockImages_Fragment
  | ContentBlock_BlockImpactStatistics_Fragment
  | ContentBlock_BlockPartners_Fragment
  | ContentBlock_BlockPeople_Fragment
  | ContentBlock_BlockPrograms_Fragment
  | ContentBlock_BlockQuotation_Fragment
  | ContentBlock_BlockQuotations_Fragment
  | ContentBlock_BlockShare_Fragment
  | ContentBlock_BlockTabs_Fragment
  | ContentBlock_BlockThermometer_Fragment
  | ContentBlock_BlockVideo_Fragment
  | ContentBlock_BlogCategory_Fragment
  | ContentBlock_BlogPost_Fragment
  | ContentBlock_Bulletin_Fragment
  | ContentBlock_BulletinBoard_Fragment
  | ContentBlock_DonationAppeal_Fragment
  | ContentBlock_EmbedInstagram_Fragment
  | ContentBlock_EmbedTwitter_Fragment
  | ContentBlock_Hero_Fragment
  | ContentBlock_Hospital_Fragment
  | ContentBlock_KnowledgeBasedResource_Fragment
  | ContentBlock_LayoutCopy_Fragment
  | ContentBlock_NavigationDropdown_Fragment
  | ContentBlock_NavigationLink_Fragment
  | ContentBlock_NavigationPrimary_Fragment
  | ContentBlock_NavigationSecondary_Fragment
  | ContentBlock_Page_Fragment
  | ContentBlock_Partner_Fragment
  | ContentBlock_Person_Fragment
  | ContentBlock_PressRelease_Fragment
  | ContentBlock_Program_Fragment
  | ContentBlock_Redirect_Fragment
  | ContentBlock_Statistic_Fragment
  | ContentBlock_Tab_Fragment
;

type Entry_BasicPage_Fragment = { __typename: 'BasicPage', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockBlogPosts_Fragment = { __typename: 'BlockBlogPosts', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockClassy_Fragment = { __typename: 'BlockClassy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockCollapsible_Fragment = { __typename: 'BlockCollapsible', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockCta_Fragment = { __typename: 'BlockCta', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockCustomComponent_Fragment = { __typename: 'BlockCustomComponent', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockDonate_Fragment = { __typename: 'BlockDonate', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockElfsightWidget_Fragment = { __typename: 'BlockElfsightWidget', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockEmailCollection_Fragment = { __typename: 'BlockEmailCollection', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockFormAssembly_Fragment = { __typename: 'BlockFormAssembly', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockFundraiseUp_Fragment = { __typename: 'BlockFundraiseUp', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockHighlight_Fragment = { __typename: 'BlockHighlight', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockImages_Fragment = { __typename: 'BlockImages', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockImpactStatistics_Fragment = { __typename: 'BlockImpactStatistics', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockPartners_Fragment = { __typename: 'BlockPartners', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockPeople_Fragment = { __typename: 'BlockPeople', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockPrograms_Fragment = { __typename: 'BlockPrograms', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockQuotation_Fragment = { __typename: 'BlockQuotation', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockQuotations_Fragment = { __typename: 'BlockQuotations', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockShare_Fragment = { __typename: 'BlockShare', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockTabs_Fragment = { __typename: 'BlockTabs', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockThermometer_Fragment = { __typename: 'BlockThermometer', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlockVideo_Fragment = { __typename: 'BlockVideo', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlogCategory_Fragment = { __typename: 'BlogCategory', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BlogPost_Fragment = { __typename: 'BlogPost', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_Bulletin_Fragment = { __typename: 'Bulletin', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_BulletinBoard_Fragment = { __typename: 'BulletinBoard', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_DonationAppeal_Fragment = { __typename: 'DonationAppeal', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_EmbedInstagram_Fragment = { __typename: 'EmbedInstagram', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_EmbedTwitter_Fragment = { __typename: 'EmbedTwitter', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_Hero_Fragment = { __typename: 'Hero', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_Hospital_Fragment = { __typename: 'Hospital', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_KnowledgeBasedResource_Fragment = { __typename: 'KnowledgeBasedResource', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_LayoutCopy_Fragment = { __typename: 'LayoutCopy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_NavigationDropdown_Fragment = { __typename: 'NavigationDropdown', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_NavigationLink_Fragment = { __typename: 'NavigationLink', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_NavigationPrimary_Fragment = { __typename: 'NavigationPrimary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_NavigationSecondary_Fragment = { __typename: 'NavigationSecondary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_Page_Fragment = { __typename: 'Page', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_Partner_Fragment = { __typename: 'Partner', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_Person_Fragment = { __typename: 'Person', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_PressRelease_Fragment = { __typename: 'PressRelease', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_Program_Fragment = { __typename: 'Program', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_Redirect_Fragment = { __typename: 'Redirect', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_Statistic_Fragment = { __typename: 'Statistic', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type Entry_Tab_Fragment = { __typename: 'Tab', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type EntryFragment =
  | Entry_BasicPage_Fragment
  | Entry_BlockBlogPosts_Fragment
  | Entry_BlockClassy_Fragment
  | Entry_BlockCollapsible_Fragment
  | Entry_BlockCta_Fragment
  | Entry_BlockCustomComponent_Fragment
  | Entry_BlockDonate_Fragment
  | Entry_BlockElfsightWidget_Fragment
  | Entry_BlockEmailCollection_Fragment
  | Entry_BlockFormAssembly_Fragment
  | Entry_BlockFundraiseUp_Fragment
  | Entry_BlockHighlight_Fragment
  | Entry_BlockImages_Fragment
  | Entry_BlockImpactStatistics_Fragment
  | Entry_BlockPartners_Fragment
  | Entry_BlockPeople_Fragment
  | Entry_BlockPrograms_Fragment
  | Entry_BlockQuotation_Fragment
  | Entry_BlockQuotations_Fragment
  | Entry_BlockShare_Fragment
  | Entry_BlockTabs_Fragment
  | Entry_BlockThermometer_Fragment
  | Entry_BlockVideo_Fragment
  | Entry_BlogCategory_Fragment
  | Entry_BlogPost_Fragment
  | Entry_Bulletin_Fragment
  | Entry_BulletinBoard_Fragment
  | Entry_DonationAppeal_Fragment
  | Entry_EmbedInstagram_Fragment
  | Entry_EmbedTwitter_Fragment
  | Entry_Hero_Fragment
  | Entry_Hospital_Fragment
  | Entry_KnowledgeBasedResource_Fragment
  | Entry_LayoutCopy_Fragment
  | Entry_NavigationDropdown_Fragment
  | Entry_NavigationLink_Fragment
  | Entry_NavigationPrimary_Fragment
  | Entry_NavigationSecondary_Fragment
  | Entry_Page_Fragment
  | Entry_Partner_Fragment
  | Entry_Person_Fragment
  | Entry_PressRelease_Fragment
  | Entry_Program_Fragment
  | Entry_Redirect_Fragment
  | Entry_Statistic_Fragment
  | Entry_Tab_Fragment
;

type LinkedContentSlugs_BasicPage_Fragment = { __typename: 'BasicPage', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockBlogPosts_Fragment = { __typename: 'BlockBlogPosts', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockClassy_Fragment = { __typename: 'BlockClassy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockCollapsible_Fragment = { __typename: 'BlockCollapsible', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockCta_Fragment = { __typename: 'BlockCta', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockCustomComponent_Fragment = { __typename: 'BlockCustomComponent', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockDonate_Fragment = { __typename: 'BlockDonate', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockElfsightWidget_Fragment = { __typename: 'BlockElfsightWidget', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockEmailCollection_Fragment = { __typename: 'BlockEmailCollection', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockFormAssembly_Fragment = { __typename: 'BlockFormAssembly', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockFundraiseUp_Fragment = { __typename: 'BlockFundraiseUp', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockHighlight_Fragment = { __typename: 'BlockHighlight', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockImages_Fragment = { __typename: 'BlockImages', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockImpactStatistics_Fragment = { __typename: 'BlockImpactStatistics', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockPartners_Fragment = { __typename: 'BlockPartners', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockPeople_Fragment = { __typename: 'BlockPeople', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockPrograms_Fragment = { __typename: 'BlockPrograms', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockQuotation_Fragment = { __typename: 'BlockQuotation', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockQuotations_Fragment = { __typename: 'BlockQuotations', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockShare_Fragment = { __typename: 'BlockShare', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockTabs_Fragment = { __typename: 'BlockTabs', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockThermometer_Fragment = { __typename: 'BlockThermometer', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlockVideo_Fragment = { __typename: 'BlockVideo', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlogCategory_Fragment = { __typename: 'BlogCategory', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BlogPost_Fragment = { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_Bulletin_Fragment = { __typename: 'Bulletin', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_BulletinBoard_Fragment = { __typename: 'BulletinBoard', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_DonationAppeal_Fragment = { __typename: 'DonationAppeal', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_EmbedInstagram_Fragment = { __typename: 'EmbedInstagram', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_EmbedTwitter_Fragment = { __typename: 'EmbedTwitter', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_Hero_Fragment = { __typename: 'Hero', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_Hospital_Fragment = { __typename: 'Hospital', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_KnowledgeBasedResource_Fragment = { __typename: 'KnowledgeBasedResource', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_LayoutCopy_Fragment = { __typename: 'LayoutCopy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_NavigationDropdown_Fragment = { __typename: 'NavigationDropdown', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_NavigationLink_Fragment = { __typename: 'NavigationLink', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_NavigationPrimary_Fragment = { __typename: 'NavigationPrimary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_NavigationSecondary_Fragment = { __typename: 'NavigationSecondary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_Page_Fragment = { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_Partner_Fragment = { __typename: 'Partner', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_Person_Fragment = { __typename: 'Person', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_PressRelease_Fragment = { __typename: 'PressRelease', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_Program_Fragment = { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_Redirect_Fragment = { __typename: 'Redirect', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_Statistic_Fragment = { __typename: 'Statistic', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

type LinkedContentSlugs_Tab_Fragment = { __typename: 'Tab', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type LinkedContentSlugsFragment =
  | LinkedContentSlugs_BasicPage_Fragment
  | LinkedContentSlugs_BlockBlogPosts_Fragment
  | LinkedContentSlugs_BlockClassy_Fragment
  | LinkedContentSlugs_BlockCollapsible_Fragment
  | LinkedContentSlugs_BlockCta_Fragment
  | LinkedContentSlugs_BlockCustomComponent_Fragment
  | LinkedContentSlugs_BlockDonate_Fragment
  | LinkedContentSlugs_BlockElfsightWidget_Fragment
  | LinkedContentSlugs_BlockEmailCollection_Fragment
  | LinkedContentSlugs_BlockFormAssembly_Fragment
  | LinkedContentSlugs_BlockFundraiseUp_Fragment
  | LinkedContentSlugs_BlockHighlight_Fragment
  | LinkedContentSlugs_BlockImages_Fragment
  | LinkedContentSlugs_BlockImpactStatistics_Fragment
  | LinkedContentSlugs_BlockPartners_Fragment
  | LinkedContentSlugs_BlockPeople_Fragment
  | LinkedContentSlugs_BlockPrograms_Fragment
  | LinkedContentSlugs_BlockQuotation_Fragment
  | LinkedContentSlugs_BlockQuotations_Fragment
  | LinkedContentSlugs_BlockShare_Fragment
  | LinkedContentSlugs_BlockTabs_Fragment
  | LinkedContentSlugs_BlockThermometer_Fragment
  | LinkedContentSlugs_BlockVideo_Fragment
  | LinkedContentSlugs_BlogCategory_Fragment
  | LinkedContentSlugs_BlogPost_Fragment
  | LinkedContentSlugs_Bulletin_Fragment
  | LinkedContentSlugs_BulletinBoard_Fragment
  | LinkedContentSlugs_DonationAppeal_Fragment
  | LinkedContentSlugs_EmbedInstagram_Fragment
  | LinkedContentSlugs_EmbedTwitter_Fragment
  | LinkedContentSlugs_Hero_Fragment
  | LinkedContentSlugs_Hospital_Fragment
  | LinkedContentSlugs_KnowledgeBasedResource_Fragment
  | LinkedContentSlugs_LayoutCopy_Fragment
  | LinkedContentSlugs_NavigationDropdown_Fragment
  | LinkedContentSlugs_NavigationLink_Fragment
  | LinkedContentSlugs_NavigationPrimary_Fragment
  | LinkedContentSlugs_NavigationSecondary_Fragment
  | LinkedContentSlugs_Page_Fragment
  | LinkedContentSlugs_Partner_Fragment
  | LinkedContentSlugs_Person_Fragment
  | LinkedContentSlugs_PressRelease_Fragment
  | LinkedContentSlugs_Program_Fragment
  | LinkedContentSlugs_Redirect_Fragment
  | LinkedContentSlugs_Statistic_Fragment
  | LinkedContentSlugs_Tab_Fragment
;

export type NavigationDropdownFragment = { __typename: 'NavigationDropdown', title: string | null, linksCollection: { items: Array<{ __typename: 'NavigationLink', title: string | null, linkStatic: string | null, description: { json: unknown } | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, linkEntryReferenceCollection: { items: Array<
          | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
         | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type NavigationLinkFragment = { __typename: 'NavigationLink', title: string | null, linkStatic: string | null, description: { json: unknown } | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, linkEntryReferenceCollection: { items: Array<
      | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
      | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
     | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetNavigationQueryVariables = Exact<{
  preview?: boolean | null | undefined;
  headerId: string;
  footerId: string;
}>;


export type GetNavigationQuery = { navigationPrimary: { __typename: 'NavigationPrimary', title: string | null, navigationItemsCollection: { items: Array<
        | { __typename: 'NavigationDropdown', title: string | null, linksCollection: { items: Array<{ __typename: 'NavigationLink', title: string | null, linkStatic: string | null, description: { json: unknown } | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, linkEntryReferenceCollection: { items: Array<
                  | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
                  | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
                  | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
                 | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
        | { __typename: 'NavigationLink', title: string | null, linkStatic: string | null, description: { json: unknown } | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, linkEntryReferenceCollection: { items: Array<
              | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
             | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
       | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, navigationSecondary: { __typename: 'NavigationSecondary', title: string | null, navigationItemsCollection: { items: Array<{ __typename: 'NavigationLink', title: string | null, linkStatic: string | null, description: { json: unknown } | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, linkEntryReferenceCollection: { items: Array<
            | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
            | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
           | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null };

export type PageFragment = { __typename: 'Page', title: string | null, slug: string | null, metaDescription: string | null, metaKeywords: Array<string | null> | null, hideNavigation: boolean | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, blocks: { total: number, skip: number, limit: number, items: Array<
      | { __typename: 'BlockBlogPosts', sys: { id: string } }
      | { __typename: 'BlockClassy', sys: { id: string } }
      | { __typename: 'BlockCollapsible', sys: { id: string } }
      | { __typename: 'BlockCta', sys: { id: string } }
      | { __typename: 'BlockCustomComponent', sys: { id: string } }
      | { __typename: 'BlockDonate', sys: { id: string } }
      | { __typename: 'BlockElfsightWidget', sys: { id: string } }
      | { __typename: 'BlockEmailCollection', sys: { id: string } }
      | { __typename: 'BlockFormAssembly', sys: { id: string } }
      | { __typename: 'BlockFundraiseUp', sys: { id: string } }
      | { __typename: 'BlockHighlight', sys: { id: string } }
      | { __typename: 'BlockImages', sys: { id: string } }
      | { __typename: 'BlockImpactStatistics', sys: { id: string } }
      | { __typename: 'BlockPartners', sys: { id: string } }
      | { __typename: 'BlockPeople', sys: { id: string } }
      | { __typename: 'BlockPrograms', sys: { id: string } }
      | { __typename: 'BlockQuotation', sys: { id: string } }
      | { __typename: 'BlockQuotations', sys: { id: string } }
      | { __typename: 'BlockShare', sys: { id: string } }
      | { __typename: 'BlockTabs', sys: { id: string } }
      | { __typename: 'BlockThermometer', sys: { id: string } }
      | { __typename: 'BlockVideo', sys: { id: string } }
      | { __typename: 'BulletinBoard', sys: { id: string } }
      | { __typename: 'Hero', sys: { id: string } }
      | { __typename: 'LayoutCopy', sys: { id: string } }
     | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetLandingPageSlugsQueryVariables = Exact<{
  limit?: number | null | undefined;
  skip?: number | null | undefined;
  where?: Types.PageFilter | null | undefined;
}>;


export type GetLandingPageSlugsQuery = { pageCollection: { total: number, skip: number, limit: number, items: Array<{ __typename: 'Page', title: string | null, slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type GetPageBySlugQueryVariables = Exact<{
  slug?: string | null | undefined;
  preview?: boolean | null | undefined;
}>;


export type GetPageBySlugQuery = { pageCollection: { total: number, skip: number, limit: number, items: Array<{ __typename: 'Page', title: string | null, slug: string | null, metaDescription: string | null, metaKeywords: Array<string | null> | null, hideNavigation: boolean | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, blocks: { total: number, skip: number, limit: number, items: Array<
          | { __typename: 'BlockBlogPosts', sys: { id: string } }
          | { __typename: 'BlockClassy', sys: { id: string } }
          | { __typename: 'BlockCollapsible', sys: { id: string } }
          | { __typename: 'BlockCta', sys: { id: string } }
          | { __typename: 'BlockCustomComponent', sys: { id: string } }
          | { __typename: 'BlockDonate', sys: { id: string } }
          | { __typename: 'BlockElfsightWidget', sys: { id: string } }
          | { __typename: 'BlockEmailCollection', sys: { id: string } }
          | { __typename: 'BlockFormAssembly', sys: { id: string } }
          | { __typename: 'BlockFundraiseUp', sys: { id: string } }
          | { __typename: 'BlockHighlight', sys: { id: string } }
          | { __typename: 'BlockImages', sys: { id: string } }
          | { __typename: 'BlockImpactStatistics', sys: { id: string } }
          | { __typename: 'BlockPartners', sys: { id: string } }
          | { __typename: 'BlockPeople', sys: { id: string } }
          | { __typename: 'BlockPrograms', sys: { id: string } }
          | { __typename: 'BlockQuotation', sys: { id: string } }
          | { __typename: 'BlockQuotations', sys: { id: string } }
          | { __typename: 'BlockShare', sys: { id: string } }
          | { __typename: 'BlockTabs', sys: { id: string } }
          | { __typename: 'BlockThermometer', sys: { id: string } }
          | { __typename: 'BlockVideo', sys: { id: string } }
          | { __typename: 'BulletinBoard', sys: { id: string } }
          | { __typename: 'Hero', sys: { id: string } }
          | { __typename: 'LayoutCopy', sys: { id: string } }
         | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type GetPageSlugByIdQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetPageSlugByIdQuery = { page: { slug: string | null } | null };

export type GetPagesQueryVariables = Exact<{
  where?: Types.PageFilter | null | undefined;
  limit?: number | null | undefined;
  skip?: number | null | undefined;
  order?: Array<Types.PageOrder | null | undefined> | Types.PageOrder | null | undefined;
  preview?: boolean | null | undefined;
}>;


export type GetPagesQuery = { pageCollection: { items: Array<{ __typename: 'Page', title: string | null, slug: string | null, metaDescription: string | null, metaKeywords: Array<string | null> | null, hideNavigation: boolean | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, blocks: { total: number, skip: number, limit: number, items: Array<
          | { __typename: 'BlockBlogPosts', sys: { id: string } }
          | { __typename: 'BlockClassy', sys: { id: string } }
          | { __typename: 'BlockCollapsible', sys: { id: string } }
          | { __typename: 'BlockCta', sys: { id: string } }
          | { __typename: 'BlockCustomComponent', sys: { id: string } }
          | { __typename: 'BlockDonate', sys: { id: string } }
          | { __typename: 'BlockElfsightWidget', sys: { id: string } }
          | { __typename: 'BlockEmailCollection', sys: { id: string } }
          | { __typename: 'BlockFormAssembly', sys: { id: string } }
          | { __typename: 'BlockFundraiseUp', sys: { id: string } }
          | { __typename: 'BlockHighlight', sys: { id: string } }
          | { __typename: 'BlockImages', sys: { id: string } }
          | { __typename: 'BlockImpactStatistics', sys: { id: string } }
          | { __typename: 'BlockPartners', sys: { id: string } }
          | { __typename: 'BlockPeople', sys: { id: string } }
          | { __typename: 'BlockPrograms', sys: { id: string } }
          | { __typename: 'BlockQuotation', sys: { id: string } }
          | { __typename: 'BlockQuotations', sys: { id: string } }
          | { __typename: 'BlockShare', sys: { id: string } }
          | { __typename: 'BlockTabs', sys: { id: string } }
          | { __typename: 'BlockThermometer', sys: { id: string } }
          | { __typename: 'BlockVideo', sys: { id: string } }
          | { __typename: 'BulletinBoard', sys: { id: string } }
          | { __typename: 'Hero', sys: { id: string } }
          | { __typename: 'LayoutCopy', sys: { id: string } }
         | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type GetPageIdBySlugQueryVariables = Exact<{
  slug: string;
  preview?: boolean | null | undefined;
}>;


export type GetPageIdBySlugQuery = { pageCollection: { items: Array<{ sys: { id: string } } | null> } | null, programCollection: { items: Array<{ sys: { id: string } } | null> } | null, basicPageCollection: { items: Array<{ sys: { id: string } } | null> } | null };

export type GetPageSlugsQueryVariables = Exact<{
  limit?: number | null | undefined;
  skip?: number | null | undefined;
  where?: Types.PageFilter | null | undefined;
  order?: Array<Types.PageOrder | null | undefined> | Types.PageOrder | null | undefined;
}>;


export type GetPageSlugsQuery = { pageCollection: { total: number, items: Array<{ __typename: 'Page', title: string | null, slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type PartnerPageFragment = { __typename: 'Partner', title: string | null, slug: string | null, headline: string | null, kicker: string | null, campaignUrl: string | null, createPage: boolean | null, metaDescription: string | null, shortDescription: { json: unknown } | null, logo: { __typename: 'Asset', width: number | null, height: number | null, url: string | null, title: string | null, description: string | null, contentType: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, blocks: { total: number, skip: number, limit: number, items: Array<
      | { __typename: 'BlockBlogPosts', sys: { id: string } }
      | { __typename: 'BlockClassy', sys: { id: string } }
      | { __typename: 'BlockCta', sys: { id: string } }
      | { __typename: 'BlockHighlight', sys: { id: string } }
      | { __typename: 'BlockImpactStatistics', sys: { id: string } }
      | { __typename: 'BlockQuotation', sys: { id: string } }
      | { __typename: 'BlockQuotations', sys: { id: string } }
      | { __typename: 'BulletinBoard', sys: { id: string } }
      | { __typename: 'LayoutCopy', sys: { id: string } }
     | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetPartnerPageSlugsQueryVariables = Exact<{
  limit?: number | null | undefined;
  skip?: number | null | undefined;
  where?: Types.PartnerFilter | null | undefined;
  order?: Array<Types.PartnerOrder | null | undefined> | Types.PartnerOrder | null | undefined;
}>;


export type GetPartnerPageSlugsQuery = { partnerCollection: { total: number, skip: number, limit: number, items: Array<{ __typename: 'Partner', title: string | null, slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type GetPartnerPagesQueryVariables = Exact<{
  where?: Types.PartnerFilter | null | undefined;
  limit?: number | null | undefined;
  skip?: number | null | undefined;
  order?: Array<Types.PartnerOrder | null | undefined> | Types.PartnerOrder | null | undefined;
  preview?: boolean | null | undefined;
}>;


export type GetPartnerPagesQuery = { partnerCollection: { items: Array<{ __typename: 'Partner', title: string | null, slug: string | null, headline: string | null, kicker: string | null, campaignUrl: string | null, createPage: boolean | null, metaDescription: string | null, shortDescription: { json: unknown } | null, logo: { __typename: 'Asset', width: number | null, height: number | null, url: string | null, title: string | null, description: string | null, contentType: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, blocks: { total: number, skip: number, limit: number, items: Array<
          | { __typename: 'BlockBlogPosts', sys: { id: string } }
          | { __typename: 'BlockClassy', sys: { id: string } }
          | { __typename: 'BlockCta', sys: { id: string } }
          | { __typename: 'BlockHighlight', sys: { id: string } }
          | { __typename: 'BlockImpactStatistics', sys: { id: string } }
          | { __typename: 'BlockQuotation', sys: { id: string } }
          | { __typename: 'BlockQuotations', sys: { id: string } }
          | { __typename: 'BulletinBoard', sys: { id: string } }
          | { __typename: 'LayoutCopy', sys: { id: string } }
         | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type GetPartnerSlugByIdQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetPartnerSlugByIdQuery = { partner: { slug: string | null } | null };

export type PressReleaseTeaserFragment = { __typename: 'PressRelease', title: string | null, slug: string | null, date: string | null, metaDescription: string | null, metaKeywords: Array<string | null> | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type PressReleasePageFragment = { __typename: 'PressRelease', title: string | null, slug: string | null, date: string | null, metaDescription: string | null, metaKeywords: Array<string | null> | null, youTubeUrl: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, text: { json: unknown, links: { entries: { block: Array<
          | { __typename: 'BasicPage' }
          | { __typename: 'BlockBlogPosts' }
          | { __typename: 'BlockClassy' }
          | { __typename: 'BlockCollapsible' }
          | { __typename: 'BlockCta' }
          | { __typename: 'BlockCustomComponent' }
          | { __typename: 'BlockDonate' }
          | { __typename: 'BlockElfsightWidget' }
          | { __typename: 'BlockEmailCollection' }
          | { __typename: 'BlockFormAssembly' }
          | { __typename: 'BlockFundraiseUp' }
          | { __typename: 'BlockHighlight' }
          | { __typename: 'BlockImages' }
          | { __typename: 'BlockImpactStatistics' }
          | { __typename: 'BlockPartners' }
          | { __typename: 'BlockPeople' }
          | { __typename: 'BlockPrograms' }
          | { __typename: 'BlockQuotation' }
          | { __typename: 'BlockQuotations' }
          | { __typename: 'BlockShare' }
          | { __typename: 'BlockTabs' }
          | { __typename: 'BlockThermometer' }
          | { __typename: 'BlockVideo' }
          | { __typename: 'BlogCategory' }
          | { __typename: 'BlogPost' }
          | { __typename: 'Bulletin' }
          | { __typename: 'BulletinBoard' }
          | { __typename: 'DonationAppeal' }
          | { __typename: 'EmbedInstagram', title: string | null, url: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'EmbedTwitter', title: string | null, url: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Hero' }
          | { __typename: 'Hospital' }
          | { __typename: 'KnowledgeBasedResource' }
          | { __typename: 'LayoutCopy' }
          | { __typename: 'NavigationDropdown' }
          | { __typename: 'NavigationLink' }
          | { __typename: 'NavigationPrimary' }
          | { __typename: 'NavigationSecondary' }
          | { __typename: 'Page' }
          | { __typename: 'Partner' }
          | { __typename: 'Person' }
          | { __typename: 'PressRelease' }
          | { __typename: 'Program' }
          | { __typename: 'Redirect' }
          | { __typename: 'Statistic' }
          | { __typename: 'Tab' }
         | null>, hyperlink: Array<
          | { __typename: 'BasicPage', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockBlogPosts', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockClassy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockCollapsible', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockCta', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockCustomComponent', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockDonate', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockElfsightWidget', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockEmailCollection', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockFormAssembly', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockFundraiseUp', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockHighlight', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockImages', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockImpactStatistics', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockPartners', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockPeople', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockPrograms', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockQuotation', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockQuotations', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockShare', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockTabs', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockThermometer', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlockVideo', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlogCategory', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Bulletin', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'BulletinBoard', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'DonationAppeal', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'EmbedInstagram', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'EmbedTwitter', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Hero', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Hospital', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'KnowledgeBasedResource', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'LayoutCopy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationDropdown', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationLink', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationPrimary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'NavigationSecondary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Partner', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Person', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'PressRelease', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Redirect', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Statistic', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
          | { __typename: 'Tab', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
         | null> }, assets: { block: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null>, hyperlink: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetPressReleasesQueryVariables = Exact<{
  where?: Types.PressReleaseFilter | null | undefined;
  limit?: number | null | undefined;
  skip?: number | null | undefined;
  order?: Array<Types.PressReleaseOrder | null | undefined> | Types.PressReleaseOrder | null | undefined;
  preview?: boolean | null | undefined;
}>;


export type GetPressReleasesQuery = { pressReleases: { total: number, skip: number, limit: number, items: Array<{ __typename: 'PressRelease', title: string | null, slug: string | null, date: string | null, metaDescription: string | null, metaKeywords: Array<string | null> | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type GetPressReleaseBySlugQueryVariables = Exact<{
  slug?: string | null | undefined;
  preview?: boolean | null | undefined;
}>;


export type GetPressReleaseBySlugQuery = { pressReleaseCollection: { items: Array<{ __typename: 'PressRelease', title: string | null, slug: string | null, date: string | null, metaDescription: string | null, metaKeywords: Array<string | null> | null, youTubeUrl: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, text: { json: unknown, links: { entries: { block: Array<
              | { __typename: 'BasicPage' }
              | { __typename: 'BlockBlogPosts' }
              | { __typename: 'BlockClassy' }
              | { __typename: 'BlockCollapsible' }
              | { __typename: 'BlockCta' }
              | { __typename: 'BlockCustomComponent' }
              | { __typename: 'BlockDonate' }
              | { __typename: 'BlockElfsightWidget' }
              | { __typename: 'BlockEmailCollection' }
              | { __typename: 'BlockFormAssembly' }
              | { __typename: 'BlockFundraiseUp' }
              | { __typename: 'BlockHighlight' }
              | { __typename: 'BlockImages' }
              | { __typename: 'BlockImpactStatistics' }
              | { __typename: 'BlockPartners' }
              | { __typename: 'BlockPeople' }
              | { __typename: 'BlockPrograms' }
              | { __typename: 'BlockQuotation' }
              | { __typename: 'BlockQuotations' }
              | { __typename: 'BlockShare' }
              | { __typename: 'BlockTabs' }
              | { __typename: 'BlockThermometer' }
              | { __typename: 'BlockVideo' }
              | { __typename: 'BlogCategory' }
              | { __typename: 'BlogPost' }
              | { __typename: 'Bulletin' }
              | { __typename: 'BulletinBoard' }
              | { __typename: 'DonationAppeal' }
              | { __typename: 'EmbedInstagram', title: string | null, url: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'EmbedTwitter', title: string | null, url: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Hero' }
              | { __typename: 'Hospital' }
              | { __typename: 'KnowledgeBasedResource' }
              | { __typename: 'LayoutCopy' }
              | { __typename: 'NavigationDropdown' }
              | { __typename: 'NavigationLink' }
              | { __typename: 'NavigationPrimary' }
              | { __typename: 'NavigationSecondary' }
              | { __typename: 'Page' }
              | { __typename: 'Partner' }
              | { __typename: 'Person' }
              | { __typename: 'PressRelease' }
              | { __typename: 'Program' }
              | { __typename: 'Redirect' }
              | { __typename: 'Statistic' }
              | { __typename: 'Tab' }
             | null>, hyperlink: Array<
              | { __typename: 'BasicPage', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockBlogPosts', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockClassy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockCollapsible', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockCta', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockCustomComponent', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockDonate', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockElfsightWidget', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockEmailCollection', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockFormAssembly', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockFundraiseUp', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockHighlight', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockImages', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockImpactStatistics', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockPartners', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockPeople', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockPrograms', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockQuotation', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockQuotations', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockShare', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockTabs', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockThermometer', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlockVideo', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlogCategory', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BlogPost', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Bulletin', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'BulletinBoard', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'DonationAppeal', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'EmbedInstagram', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'EmbedTwitter', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Hero', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Hospital', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'KnowledgeBasedResource', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'LayoutCopy', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'NavigationDropdown', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'NavigationLink', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'NavigationPrimary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'NavigationSecondary', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Page', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Partner', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Person', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'PressRelease', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Program', slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Redirect', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Statistic', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
              | { __typename: 'Tab', sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } }
             | null> }, assets: { block: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null>, hyperlink: Array<{ __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type GetPressReleaseSlugByIdQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetPressReleaseSlugByIdQuery = { pressRelease: { slug: string | null } | null };

export type GetPressReleaseSlugsQueryVariables = Exact<{
  limit?: number | null | undefined;
  skip?: number | null | undefined;
}>;


export type GetPressReleaseSlugsQuery = { pressReleaseCollection: { total: number, items: Array<{ __typename: 'PressRelease', title: string | null, slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type ProgramPageFragment = { __typename: 'Program', title: string | null, slug: string | null, overview: string | null, metaKeywords: Array<string | null> | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, blocks: { total: number, skip: number, limit: number, items: Array<
      | { __typename: 'BlockClassy', sys: { id: string } }
      | { __typename: 'BlockCollapsible', sys: { id: string } }
      | { __typename: 'BlockCustomComponent', sys: { id: string } }
      | { __typename: 'BlockDonate', sys: { id: string } }
      | { __typename: 'BlockEmailCollection', sys: { id: string } }
      | { __typename: 'BlockFundraiseUp', sys: { id: string } }
      | { __typename: 'BlockHighlight', sys: { id: string } }
      | { __typename: 'BlockImages', sys: { id: string } }
      | { __typename: 'BlockImpactStatistics', sys: { id: string } }
      | { __typename: 'BlockPeople', sys: { id: string } }
      | { __typename: 'BlockPrograms', sys: { id: string } }
      | { __typename: 'BlockQuotation', sys: { id: string } }
      | { __typename: 'BlockQuotations', sys: { id: string } }
      | { __typename: 'BlockTabs', sys: { id: string } }
      | { __typename: 'BlockVideo', sys: { id: string } }
      | { __typename: 'BulletinBoard', sys: { id: string } }
      | { __typename: 'Hero', sys: { id: string } }
      | { __typename: 'LayoutCopy', sys: { id: string } }
     | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type ProgramFragment = { __typename: 'Program', title: string | null, slug: string | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } };

export type GetProgramPageSlugsQueryVariables = Exact<{
  limit?: number | null | undefined;
  skip?: number | null | undefined;
  where?: Types.ProgramFilter | null | undefined;
  order?: Array<Types.ProgramOrder | null | undefined> | Types.ProgramOrder | null | undefined;
}>;


export type GetProgramPageSlugsQuery = { programCollection: { total: number, items: Array<{ __typename: 'Program', title: string | null, slug: string | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type GetProgramPageBySlugQueryVariables = Exact<{
  slug?: string | null | undefined;
  preview?: boolean | null | undefined;
}>;


export type GetProgramPageBySlugQuery = { programCollection: { total: number, skip: number, limit: number, items: Array<{ __typename: 'Program', title: string | null, slug: string | null, overview: string | null, metaKeywords: Array<string | null> | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, blocks: { total: number, skip: number, limit: number, items: Array<
          | { __typename: 'BlockClassy', sys: { id: string } }
          | { __typename: 'BlockCollapsible', sys: { id: string } }
          | { __typename: 'BlockCustomComponent', sys: { id: string } }
          | { __typename: 'BlockDonate', sys: { id: string } }
          | { __typename: 'BlockEmailCollection', sys: { id: string } }
          | { __typename: 'BlockFundraiseUp', sys: { id: string } }
          | { __typename: 'BlockHighlight', sys: { id: string } }
          | { __typename: 'BlockImages', sys: { id: string } }
          | { __typename: 'BlockImpactStatistics', sys: { id: string } }
          | { __typename: 'BlockPeople', sys: { id: string } }
          | { __typename: 'BlockPrograms', sys: { id: string } }
          | { __typename: 'BlockQuotation', sys: { id: string } }
          | { __typename: 'BlockQuotations', sys: { id: string } }
          | { __typename: 'BlockTabs', sys: { id: string } }
          | { __typename: 'BlockVideo', sys: { id: string } }
          | { __typename: 'BulletinBoard', sys: { id: string } }
          | { __typename: 'Hero', sys: { id: string } }
          | { __typename: 'LayoutCopy', sys: { id: string } }
         | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type GetProgramSlugByIdQueryVariables = Exact<{
  id: string;
  preview?: boolean | null | undefined;
}>;


export type GetProgramSlugByIdQuery = { program: { slug: string | null } | null };

export type GetProgramsQueryVariables = Exact<{
  where?: Types.ProgramFilter | null | undefined;
  limit?: number | null | undefined;
  skip?: number | null | undefined;
  order?: Array<Types.ProgramOrder | null | undefined> | Types.ProgramOrder | null | undefined;
  preview?: boolean | null | undefined;
}>;


export type GetProgramsQuery = { programCollection: { items: Array<{ __typename: 'Program', title: string | null, slug: string | null, overview: string | null, metaKeywords: Array<string | null> | null, image: { __typename: 'Asset', url: string | null, title: string | null, description: string | null, contentType: string | null, height: number | null, width: number | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null, blocks: { total: number, skip: number, limit: number, items: Array<
          | { __typename: 'BlockClassy', sys: { id: string } }
          | { __typename: 'BlockCollapsible', sys: { id: string } }
          | { __typename: 'BlockCustomComponent', sys: { id: string } }
          | { __typename: 'BlockDonate', sys: { id: string } }
          | { __typename: 'BlockEmailCollection', sys: { id: string } }
          | { __typename: 'BlockFundraiseUp', sys: { id: string } }
          | { __typename: 'BlockHighlight', sys: { id: string } }
          | { __typename: 'BlockImages', sys: { id: string } }
          | { __typename: 'BlockImpactStatistics', sys: { id: string } }
          | { __typename: 'BlockPeople', sys: { id: string } }
          | { __typename: 'BlockPrograms', sys: { id: string } }
          | { __typename: 'BlockQuotation', sys: { id: string } }
          | { __typename: 'BlockQuotations', sys: { id: string } }
          | { __typename: 'BlockTabs', sys: { id: string } }
          | { __typename: 'BlockVideo', sys: { id: string } }
          | { __typename: 'BulletinBoard', sys: { id: string } }
          | { __typename: 'Hero', sys: { id: string } }
          | { __typename: 'LayoutCopy', sys: { id: string } }
         | null> } | null, sys: { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null } } | null> } | null };

export type GetRedirectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRedirectsQuery = { redirectCollection: { items: Array<{ source: string | null, destination: string | null } | null> } | null };

export type GetRedirectBySourceQueryVariables = Exact<{
  source: string;
}>;


export type GetRedirectBySourceQuery = { redirectCollection: { items: Array<{ source: string | null, destination: string | null } | null> } | null };

export type SysFragment = { id: string, spaceId: string, environmentId: string, publishedAt: string | null, firstPublishedAt: string | null };

export const SysFragmentDoc = gql`
    fragment Sys on Sys {
  id
  spaceId
  environmentId
  publishedAt
  firstPublishedAt
}
    `;
export const EntryFragmentDoc = gql`
    fragment Entry on Entry {
  __typename
  sys {
    ...Sys
  }
}
    ${SysFragmentDoc}`;
export const AssetFragmentDoc = gql`
    fragment Asset on Asset {
  __typename
  sys {
    ...Sys
  }
  url
  title
  description
  contentType
  height
  width
}
    ${SysFragmentDoc}`;
export const LinkedContentSlugsFragmentDoc = gql`
    fragment LinkedContentSlugs on Entry {
  ...Entry
  ... on Page {
    slug
  }
  ... on BlogPost {
    slug
  }
  ... on Program {
    slug
  }
  ... on PressRelease {
    slug
  }
}
    ${EntryFragmentDoc}`;
export const BasicPageFragmentDoc = gql`
    fragment BasicPage on BasicPage {
  ...Entry
  title
  slug
  metaDescription
  metaKeywords
  image {
    ...Asset
  }
  copy {
    json
    links {
      entries {
        hyperlink {
          ...LinkedContentSlugs
        }
      }
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const BlogCategoryFragmentDoc = gql`
    fragment BlogCategory on BlogCategory {
  sys {
    id
  }
  title
  icon {
    ...Asset
  }
  color
}
    ${AssetFragmentDoc}`;
export const BlogTeaserFragmentDoc = gql`
    fragment BlogTeaser on BlogPost {
  ...Entry
  title
  slug
  image {
    ...Asset
  }
  categories: categoriesCollection(limit: 2) {
    items {
      ...BlogCategory
    }
  }
  date
  summary
  metaDescription
  metaKeywords
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${BlogCategoryFragmentDoc}`;
export const BlockBlogPostsFragmentDoc = gql`
    fragment BlockBlogPosts on BlockBlogPosts {
  ...Entry
  headline
  blogPostsCollection {
    items {
      ...BlogTeaser
    }
  }
}
    ${EntryFragmentDoc}
${BlogTeaserFragmentDoc}`;
export const BulletinItemFragmentDoc = gql`
    fragment BulletinItem on Bulletin {
  ...Entry
  image {
    ...Asset
  }
  imageCaption
  icon
  copy
  title
  ctaTitle
  ctaLinkAsset {
    ...Asset
  }
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const BlockBulletinBoardFragmentDoc = gql`
    fragment BlockBulletinBoard on BulletinBoard {
  ...Entry
  icon
  headline
  ctaHeadline
  ctaTitle
  ctaLinkAsset {
    ...Asset
  }
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  visualStyle
  separator
  bulletinsCollection(limit: 20) {
    items {
      ...BulletinItem
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}
${BulletinItemFragmentDoc}`;
export const BlockClassyFragmentDoc = gql`
    fragment BlockClassy on BlockClassy {
  ...Entry
  image {
    ...Asset
  }
  headline
  campaignId
  recurringNudges
  size
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}`;
export const ContentBlockFragmentDoc = gql`
    fragment ContentBlock on Entry {
  __typename
  sys {
    id
  }
}
    `;
export const BlockCollapsibleFragmentDoc = gql`
    fragment BlockCollapsible on BlockCollapsible {
  ...Entry
  ctaTitle
  block {
    ...ContentBlock
  }
  collapsedBlock {
    ...ContentBlock
  }
}
    ${EntryFragmentDoc}
${ContentBlockFragmentDoc}`;
export const BlockCopyFragmentDoc = gql`
    fragment BlockCopy on LayoutCopy {
  ...Entry
  icon
  headline
  text: copy {
    json
    links {
      entries {
        block {
          __typename
          ... on EmbedInstagram {
            ...Entry
            title
            url
          }
          ... on EmbedTwitter {
            ...Entry
            title
            url
          }
        }
        hyperlink {
          __typename
          ...LinkedContentSlugs
        }
      }
      assets {
        block {
          __typename
          ...Asset
        }
        hyperlink {
          ...Asset
        }
      }
    }
  }
  ctaHeadline
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  visualStyle
  dropCap
  separator
}
    ${EntryFragmentDoc}
${LinkedContentSlugsFragmentDoc}
${AssetFragmentDoc}`;
export const BlockCtaFragmentDoc = gql`
    fragment BlockCta on BlockCta {
  ...Entry
  headline
  copy {
    json
    links {
      entries {
        hyperlink {
          __typename
          ...LinkedContentSlugs
        }
      }
      assets {
        block {
          __typename
          ...Asset
        }
        hyperlink {
          ...Asset
        }
      }
    }
  }
  image {
    ...Asset
  }
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  variant
}
    ${EntryFragmentDoc}
${LinkedContentSlugsFragmentDoc}
${AssetFragmentDoc}`;
export const BlockCustomComponentFragmentDoc = gql`
    fragment BlockCustomComponent on BlockCustomComponent {
  ...Entry
  componentName
}
    ${EntryFragmentDoc}`;
export const DonateAppealItemFragmentDoc = gql`
    fragment DonateAppealItem on DonationAppeal {
  ...Entry
  icon
  headline
  copy
  image {
    ...Asset
  }
  imageCaption
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  moreLink
  moreLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  moreLinkAsset {
    ...Asset
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const BlockDonateFragmentDoc = gql`
    fragment BlockDonate on BlockDonate {
  ...Entry
  icon
  headline
  separator
  donationAppealsCollection(limit: 3) {
    items {
      ...DonateAppealItem
    }
  }
}
    ${EntryFragmentDoc}
${DonateAppealItemFragmentDoc}`;
export const BlockElfsightWidgetFragmentDoc = gql`
    fragment BlockElfsightWidget on BlockElfsightWidget {
  ...Entry
  headline
  icon
  appId
  separator
}
    ${EntryFragmentDoc}`;
export const BlockEmailCollectionFragmentDoc = gql`
    fragment BlockEmailCollection on BlockEmailCollection {
  ...Entry
  heading
  copy
  icon
  ctaTitle
  formId
  separator
  urlEndpoint
}
    ${EntryFragmentDoc}`;
export const BlockFormAssemblyFragmentDoc = gql`
    fragment BlockFormAssembly on BlockFormAssembly {
  ...Entry
  html
  separator
}
    ${EntryFragmentDoc}`;
export const BlockFundraiseUpFragmentDoc = gql`
    fragment BlockFundraiseUp on BlockFundraiseUp {
  ...Entry
  elementId
  image {
    ...Asset
  }
  headline
  widgetType
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}`;
export const BlockHeroFragmentDoc = gql`
    fragment BlockHero on Hero {
  ...Entry
  kicker
  headline
  copy
  image {
    ...Asset
  }
  logo {
    ...Asset
  }
  videoAsset {
    ...Asset
  }
  ctaTitlePrimary
  ctaLinkPrimary
  ctaLinkContentPrimaryCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAssetPrimary {
    ...Asset
  }
  ctaTitleSecondary
  ctaLinkSecondary
  ctaLinkContentSecondaryCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAssetSecondary {
    ...Asset
  }
  ctaProminence
  separator
  aspectRatio
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const BlockHighlightFragmentDoc = gql`
    fragment BlockHighlight on BlockHighlight {
  ...Entry
  headline
  copy
  text {
    json
    links {
      entries {
        hyperlink {
          __typename
          ...LinkedContentSlugs
        }
      }
      assets {
        block {
          __typename
          ...Asset
        }
        hyperlink {
          ...Asset
        }
      }
    }
  }
  image {
    ...Asset
  }
  imageCaption
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  ctaVariant
  decoration
  aspectRatio
  reversed
  videoAsset {
    ...Asset
  }
  background
}
    ${EntryFragmentDoc}
${LinkedContentSlugsFragmentDoc}
${AssetFragmentDoc}`;
export const BlockImagesFragmentDoc = gql`
    fragment BlockImages on BlockImages {
  ...Entry
  icon
  headline
  ctaHeadline
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  separator
  imagesCollection(limit: 10) {
    items {
      title
      description
      ...Asset
    }
  }
}
    ${EntryFragmentDoc}
${LinkedContentSlugsFragmentDoc}
${AssetFragmentDoc}`;
export const StatisticItemFragmentDoc = gql`
    fragment StatisticItem on Statistic {
  ...Entry
  image {
    ...Asset
  }
  headline
  copy
  ctaHeadline
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  statType
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const BlockStatisticsFragmentDoc = gql`
    fragment BlockStatistics on BlockImpactStatistics {
  ...Entry
  icon
  headline
  copy
  statisticsCollection(limit: 4) {
    items {
      ...StatisticItem
    }
  }
  ctaHeadline
  ctaTitle
  ctaLink
  ctaLinkAsset {
    ...Asset
  }
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  separator
}
    ${EntryFragmentDoc}
${StatisticItemFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const PartnerTeaserFragmentDoc = gql`
    fragment PartnerTeaser on Partner {
  ...Entry
  title
  shortDescription {
    json
  }
  slug
  logo {
    ...Asset
    width
    height
  }
  image {
    ...Asset
    width
    height
  }
  createPage
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}`;
export const BlockPartnersFragmentDoc = gql`
    fragment BlockPartners on BlockPartners {
  ...Entry
  headline
  partnersCollection {
    items {
      ...PartnerTeaser
    }
  }
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  layout
}
    ${EntryFragmentDoc}
${PartnerTeaserFragmentDoc}
${LinkedContentSlugsFragmentDoc}
${AssetFragmentDoc}`;
export const PersonItemFragmentDoc = gql`
    fragment PersonItem on Person {
  ...Entry
  fullName
  firstName
  lastName
  jobTitle
  emailAddress
  photo {
    ...Asset
  }
  shortBio
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}`;
export const BlockPeopleFragmentDoc = gql`
    fragment BlockPeople on BlockPeople {
  ...Entry
  headline
  icon
  separator
  peopleCollection(limit: 10) {
    items {
      ...PersonItem
    }
  }
}
    ${EntryFragmentDoc}
${PersonItemFragmentDoc}`;
export const ProgramItemFragmentDoc = gql`
    fragment ProgramItem on Program {
  ...Entry
  title
  icon
  slug
  overview
  donateLink
  image {
    ...Asset
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}`;
export const BlockProgramsFragmentDoc = gql`
    fragment BlockPrograms on BlockPrograms {
  ...Entry
  icon
  headline
  separator
  programsCollection(limit: 10) {
    items {
      ...ProgramItem
    }
  }
}
    ${EntryFragmentDoc}
${ProgramItemFragmentDoc}`;
export const BlockQuotationFragmentDoc = gql`
    fragment BlockQuotation on BlockQuotation {
  ...Entry
  quote
  image {
    ...Asset
  }
  attribution
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  separator
  variant
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const BlockQuotationsFragmentDoc = gql`
    fragment BlockQuotations on BlockQuotations {
  ...Entry
  quotationsCollection {
    items {
      ...BlockQuotation
    }
  }
  variant
}
    ${EntryFragmentDoc}
${BlockQuotationFragmentDoc}`;
export const BlockShareFragmentDoc = gql`
    fragment BlockShare on BlockShare {
  ...Entry
  icon
  heading
  copy
  url
  separator
}
    ${EntryFragmentDoc}`;
export const TabItemFragmentDoc = gql`
    fragment TabItem on Tab {
  ...Entry
  headline
  image {
    ...Asset
  }
  copy {
    json
    links {
      assets {
        hyperlink {
          ...Asset
        }
      }
    }
  }
  ctaTitlePrimary
  ctaLinkPrimary
  ctaLinkContentPrimaryCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAssetPrimary {
    ...Asset
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const BlockTabsFragmentDoc = gql`
    fragment BlockTabs on BlockTabs {
  ...Entry
  tabsCollection(limit: 10) {
    items {
      ...TabItem
    }
  }
}
    ${EntryFragmentDoc}
${TabItemFragmentDoc}`;
export const BlockThermometerFragmentDoc = gql`
    fragment BlockThermometer on BlockThermometer {
  ...Entry
  title
  milestones
  amountRaised
  amountGoal
  confettiType
}
    ${EntryFragmentDoc}`;
export const BlockVideoFragmentDoc = gql`
    fragment BlockVideo on BlockVideo {
  ...Entry
  icon
  headline
  autoplay
  playerSize
  thumbnail {
    ...Asset
  }
  videoUrl
  description
  ctaHeadline
  ctaTitle
  ctaLink
  ctaLinkContentCollection(limit: 1) {
    items {
      ...LinkedContentSlugs
    }
  }
  ctaLinkAsset {
    ...Asset
  }
  separator
  videoAsset {
    ...Asset
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const BlogPageFragmentDoc = gql`
    fragment BlogPage on BlogPost {
  ...Entry
  title
  slug
  image {
    ...Asset
  }
  date
  metaDescription
  metaKeywords
  blocks: contentBlocksCollection(limit: 40) {
    total
    skip
    limit
    items {
      ...ContentBlock
    }
  }
  closerBlocks: closerBlocksCollection(limit: 2) {
    total
    skip
    limit
    items {
      ...ContentBlock
    }
  }
  authors: authorsCollection(limit: 2) {
    items {
      ...PersonItem
    }
  }
  categories: categoriesCollection(limit: 2) {
    items {
      ...BlogCategory
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${ContentBlockFragmentDoc}
${PersonItemFragmentDoc}
${BlogCategoryFragmentDoc}`;
export const NavigationDropdownFragmentDoc = gql`
    fragment NavigationDropdown on NavigationDropdown {
  ...Entry
  title
  linksCollection(limit: 12) {
    items {
      title
      description {
        json
      }
      image {
        ...Asset
      }
      ...Entry
      linkStatic
      linkEntryReferenceCollection(limit: 10) {
        items {
          ...LinkedContentSlugs
        }
      }
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const NavigationLinkFragmentDoc = gql`
    fragment NavigationLink on NavigationLink {
  ...Entry
  title
  description {
    json
  }
  image {
    ...Asset
  }
  linkStatic
  linkEntryReferenceCollection(limit: 10) {
    items {
      ...LinkedContentSlugs
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const PageFragmentDoc = gql`
    fragment Page on Page {
  ...Entry
  title
  slug
  metaDescription
  metaKeywords
  hideNavigation
  image {
    ...Asset
  }
  blocks: contentBlocksCollection(limit: 40) {
    total
    skip
    limit
    items {
      ...ContentBlock
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${ContentBlockFragmentDoc}`;
export const PartnerPageFragmentDoc = gql`
    fragment PartnerPage on Partner {
  ...Entry
  title
  slug
  headline
  kicker
  shortDescription {
    json
  }
  logo {
    ...Asset
    width
    height
  }
  image {
    ...Asset
  }
  campaignUrl
  blocks: contentBlocksCollection(limit: 40) {
    total
    skip
    limit
    items {
      ...ContentBlock
    }
  }
  createPage
  metaDescription
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${ContentBlockFragmentDoc}`;
export const PressReleaseTeaserFragmentDoc = gql`
    fragment PressReleaseTeaser on PressRelease {
  ...Entry
  title
  slug
  image {
    ...Asset
  }
  date
  metaDescription
  metaKeywords
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}`;
export const PressReleasePageFragmentDoc = gql`
    fragment PressReleasePage on PressRelease {
  ...Entry
  title
  slug
  image {
    ...Asset
  }
  date
  metaDescription
  metaKeywords
  youTubeUrl
  text {
    json
    links {
      entries {
        block {
          __typename
          ... on EmbedInstagram {
            ...Entry
            title
            url
          }
          ... on EmbedTwitter {
            ...Entry
            title
            url
          }
        }
        hyperlink {
          __typename
          ...LinkedContentSlugs
        }
      }
      assets {
        block {
          __typename
          ...Asset
        }
        hyperlink {
          ...Asset
        }
      }
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${LinkedContentSlugsFragmentDoc}`;
export const ProgramPageFragmentDoc = gql`
    fragment ProgramPage on Program {
  ...Entry
  title
  slug
  overview
  metaKeywords
  image {
    ...Asset
  }
  blocks: contentBlocksCollection(limit: 40) {
    total
    skip
    limit
    items {
      ...ContentBlock
    }
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}
${ContentBlockFragmentDoc}`;
export const ProgramFragmentDoc = gql`
    fragment Program on Program {
  ...Entry
  title
  slug
  image {
    ...Asset
  }
}
    ${EntryFragmentDoc}
${AssetFragmentDoc}`;
export const GetBasicPageBySlugDocument = gql`
    query getBasicPageBySlug($slug: String, $preview: Boolean) {
  basicPageCollection(where: { slug: $slug }, preview: $preview, limit: 1) {
    items {
      ...BasicPage
    }
  }
}
    ${BasicPageFragmentDoc}`;
export const GetBasicPageSlugByIdDocument = gql`
    query getBasicPageSlugById($id: String!, $preview: Boolean) {
  basicPage(id: $id, preview: $preview) {
    slug
  }
}
    `;
export const GetBasicPageSlugsDocument = gql`
    query getBasicPageSlugs($limit: Int, $skip: Int) {
  basicPageCollection(limit: $limit, skip: $skip) {
    total
    items {
      ...Entry
      title
      slug
    }
  }
}
    ${EntryFragmentDoc}`;
export const GetBlockBlogPostsDocument = gql`
    query getBlockBlogPosts($id: String!, $preview: Boolean) {
  blockBlogPosts(id: $id, preview: $preview) {
    ...BlockBlogPosts
  }
}
    ${BlockBlogPostsFragmentDoc}`;
export const GetBlockBulletinBoardDocument = gql`
    query getBlockBulletinBoard($id: String!, $preview: Boolean) {
  bulletinBoard(id: $id, preview: $preview) {
    ...BlockBulletinBoard
  }
}
    ${BlockBulletinBoardFragmentDoc}`;
export const GetBlockBulletinBoardIdsByBulletinIdDocument = gql`
    query getBlockBulletinBoardIdsByBulletinId($id: String!) {
  bulletin(id: $id) {
    linkedFrom {
      bulletinBoardCollection {
        items {
          sys {
            id
          }
        }
      }
    }
  }
}
    `;
export const GetBlockClassyDocument = gql`
    query getBlockClassy($id: String!, $preview: Boolean) {
  blockClassy(id: $id, preview: $preview) {
    ...BlockClassy
  }
}
    ${BlockClassyFragmentDoc}`;
export const GetBlockCollapsibleDocument = gql`
    query getBlockCollapsible($id: String!, $preview: Boolean) {
  blockCollapsible(id: $id, preview: $preview) {
    ...BlockCollapsible
  }
}
    ${BlockCollapsibleFragmentDoc}`;
export const GetBlockCopyDocument = gql`
    query getBlockCopy($id: String!, $preview: Boolean) {
  layoutCopy(id: $id, preview: $preview) {
    ...BlockCopy
  }
}
    ${BlockCopyFragmentDoc}`;
export const GetBlockCtaDocument = gql`
    query getBlockCta($id: String!, $preview: Boolean) {
  blockCta(id: $id, preview: $preview) {
    ...BlockCta
  }
}
    ${BlockCtaFragmentDoc}`;
export const GetBlockCustomComponentDocument = gql`
    query getBlockCustomComponent($id: String!, $preview: Boolean) {
  blockCustomComponent(id: $id, preview: $preview) {
    ...BlockCustomComponent
  }
}
    ${BlockCustomComponentFragmentDoc}`;
export const GetBlockDonateDocument = gql`
    query getBlockDonate($id: String!, $preview: Boolean) {
  blockDonate(id: $id, preview: $preview) {
    ...BlockDonate
  }
}
    ${BlockDonateFragmentDoc}`;
export const GetBlockDonateIdsByDonationAppealIdDocument = gql`
    query getBlockDonateIdsByDonationAppealId($id: String!) {
  donationAppeal(id: $id) {
    linkedFrom {
      blockDonateCollection {
        items {
          sys {
            id
          }
        }
      }
    }
  }
}
    `;
export const GetBlockElfsightCalendarDocument = gql`
    query getBlockElfsightCalendar($id: String!, $preview: Boolean) {
  blockElfsightWidget(id: $id, preview: $preview) {
    ...BlockElfsightWidget
  }
}
    ${BlockElfsightWidgetFragmentDoc}`;
export const GetBlockEmailCollectionDocument = gql`
    query getBlockEmailCollection($id: String!, $preview: Boolean) {
  blockEmailCollection(id: $id, preview: $preview) {
    ...BlockEmailCollection
  }
}
    ${BlockEmailCollectionFragmentDoc}`;
export const GetBlockFormAssemblyDocument = gql`
    query getBlockFormAssembly($id: String!, $preview: Boolean) {
  blockFormAssembly(id: $id, preview: $preview) {
    ...BlockFormAssembly
  }
}
    ${BlockFormAssemblyFragmentDoc}`;
export const GetBlockFundraiseUpDocument = gql`
    query getBlockFundraiseUp($id: String!, $preview: Boolean) {
  blockFundraiseUp(id: $id, preview: $preview) {
    ...BlockFundraiseUp
  }
}
    ${BlockFundraiseUpFragmentDoc}`;
export const GetBlockHeroDocument = gql`
    query getBlockHero($id: String!, $preview: Boolean) {
  hero(id: $id, preview: $preview) {
    ...BlockHero
  }
}
    ${BlockHeroFragmentDoc}`;
export const GetBlockHighlightDocument = gql`
    query getBlockHighlight($id: String!, $preview: Boolean) {
  blockHighlight(id: $id, preview: $preview) {
    ...BlockHighlight
  }
}
    ${BlockHighlightFragmentDoc}`;
export const GetBlockImagesDocument = gql`
    query getBlockImages($id: String!, $preview: Boolean) {
  blockImages(id: $id, preview: $preview) {
    ...BlockImages
  }
}
    ${BlockImagesFragmentDoc}`;
export const GetBlockStatisticsDocument = gql`
    query getBlockStatistics($id: String!, $preview: Boolean) {
  blockImpactStatistics(id: $id, preview: $preview) {
    ...BlockStatistics
  }
}
    ${BlockStatisticsFragmentDoc}`;
export const GetBlockImpactStatisticIdsByStatisticIdDocument = gql`
    query getBlockImpactStatisticIdsByStatisticId($id: String!) {
  statistic(id: $id) {
    linkedFrom {
      blockImpactStatisticsCollection {
        items {
          sys {
            id
          }
        }
      }
    }
  }
}
    `;
export const GetBlockPartnersDocument = gql`
    query getBlockPartners($id: String!, $preview: Boolean) {
  blockPartners(id: $id, preview: $preview) {
    ...BlockPartners
  }
}
    ${BlockPartnersFragmentDoc}`;
export const GetBlockPeopleDocument = gql`
    query getBlockPeople($id: String!, $preview: Boolean) {
  blockPeople(id: $id, preview: $preview) {
    ...BlockPeople
  }
}
    ${BlockPeopleFragmentDoc}`;
export const GetBlockPeopleIdsByPersonIdDocument = gql`
    query getBlockPeopleIdsByPersonId($id: String!) {
  person(id: $id) {
    linkedFrom {
      blockPeopleCollection {
        items {
          sys {
            id
          }
        }
      }
    }
  }
}
    `;
export const GetBlockProgramsDocument = gql`
    query getBlockPrograms($id: String!, $preview: Boolean) {
  blockPrograms(id: $id, preview: $preview) {
    ...BlockPrograms
  }
}
    ${BlockProgramsFragmentDoc}`;
export const GetBlockProgramIdsByProgramIdDocument = gql`
    query getBlockProgramIdsByProgramId($id: String!) {
  program(id: $id) {
    linkedFrom {
      blockProgramsCollection {
        items {
          sys {
            id
          }
        }
      }
    }
  }
}
    `;
export const GetBlockQuotationDocument = gql`
    query getBlockQuotation($id: String!, $preview: Boolean) {
  blockQuotation(id: $id, preview: $preview) {
    ...BlockQuotation
  }
}
    ${BlockQuotationFragmentDoc}`;
export const GetBlockQuotationsDocument = gql`
    query getBlockQuotations($id: String!, $preview: Boolean) {
  blockQuotations(id: $id, preview: $preview) {
    ...BlockQuotations
  }
}
    ${BlockQuotationsFragmentDoc}`;
export const GetBlockShareDocument = gql`
    query getBlockShare($id: String!, $preview: Boolean) {
  blockShare(id: $id, preview: $preview) {
    ...BlockShare
  }
}
    ${BlockShareFragmentDoc}`;
export const GetBlockTabsDocument = gql`
    query getBlockTabs($id: String!, $preview: Boolean) {
  blockTabs(id: $id, preview: $preview) {
    ...BlockTabs
  }
}
    ${BlockTabsFragmentDoc}`;
export const GetBlockTabsIdsByTabIdDocument = gql`
    query getBlockTabsIdsByTabId($id: String!) {
  tab(id: $id) {
    linkedFrom {
      blockTabsCollection {
        items {
          sys {
            id
          }
        }
      }
    }
  }
}
    `;
export const GetBlockThermometerDocument = gql`
    query getBlockThermometer($id: String!, $preview: Boolean) {
  blockThermometer(id: $id, preview: $preview) {
    ...BlockThermometer
  }
}
    ${BlockThermometerFragmentDoc}`;
export const GetBlockVideoDocument = gql`
    query getBlockVideo($id: String!, $preview: Boolean) {
  blockVideo(id: $id, preview: $preview) {
    ...BlockVideo
  }
}
    ${BlockVideoFragmentDoc}`;
export const GetBlogSlugsDocument = gql`
    query getBlogSlugs($limit: Int, $skip: Int, $where: BlogPostFilter, $order: [BlogPostOrder] = date_DESC) {
  blogPostCollection(limit: $limit, skip: $skip, order: date_DESC, where: $where) {
    total
    items {
      ...Entry
      title
      slug
    }
  }
}
    ${EntryFragmentDoc}`;
export const GetBlogPostsDocument = gql`
    query getBlogPosts($where: BlogPostFilter, $limit: Int, $skip: Int, $order: [BlogPostOrder] = date_DESC, $preview: Boolean = false) {
  blogs: blogPostCollection(
    skip: $skip
    limit: $limit
    preview: $preview
    where: $where
    order: $order
  ) {
    total
    skip
    limit
    items {
      ...BlogTeaser
    }
  }
}
    ${BlogTeaserFragmentDoc}`;
export const SearchBlogPostsDocument = gql`
    query searchBlogPosts($where: BlogPostFilter, $limit: Int, $skip: Int, $order: [BlogPostOrder] = date_DESC, $preview: Boolean = false) {
  blogs: blogPostCollection(
    skip: $skip
    limit: $limit
    preview: $preview
    where: $where
    order: $order
  ) {
    total
    skip
    limit
    items {
      ...BlogTeaser
    }
  }
}
    ${BlogTeaserFragmentDoc}`;
export const GetBlogPostBySlugDocument = gql`
    query getBlogPostBySlug($slug: String, $preview: Boolean) {
  blogPostCollection(where: { slug: $slug }, preview: $preview, limit: 1) {
    items {
      ...BlogPage
    }
  }
}
    ${BlogPageFragmentDoc}`;
export const GetBlogPostSlugByIdDocument = gql`
    query getBlogPostSlugById($id: String!, $preview: Boolean) {
  blogPost(id: $id, preview: $preview) {
    slug
  }
}
    `;
export const GetBlogPostSlugsDocument = gql`
    query getBlogPostSlugs($limit: Int, $skip: Int) {
  blogPostCollection(limit: $limit, skip: $skip) {
    total
    items {
      ...Entry
      title
      slug
    }
  }
}
    ${EntryFragmentDoc}`;
export const GetNavigationDocument = gql`
    query getNavigation($preview: Boolean, $headerId: String!, $footerId: String!) {
  navigationPrimary(id: $headerId, preview: $preview) {
    title
    ...Entry
    navigationItemsCollection(limit: 10) {
      items {
        ...NavigationDropdown
        ...NavigationLink
      }
    }
  }
  navigationSecondary(id: $footerId, preview: $preview) {
    title
    ...Entry
    navigationItemsCollection(limit: 12) {
      items {
        ...NavigationLink
      }
    }
  }
}
    ${EntryFragmentDoc}
${NavigationDropdownFragmentDoc}
${NavigationLinkFragmentDoc}`;
export const GetLandingPageSlugsDocument = gql`
    query getLandingPageSlugs($limit: Int, $skip: Int, $where: PageFilter) {
  pageCollection(limit: $limit, skip: $skip, where: $where) {
    total
    skip
    limit
    items {
      ...Entry
      title
      slug
    }
  }
}
    ${EntryFragmentDoc}`;
export const GetPageBySlugDocument = gql`
    query getPageBySlug($slug: String, $preview: Boolean) {
  pageCollection(where: { slug: $slug }, preview: $preview, limit: 1) {
    total
    skip
    limit
    items {
      ...Page
    }
  }
}
    ${PageFragmentDoc}`;
export const GetPageSlugByIdDocument = gql`
    query getPageSlugById($id: String!, $preview: Boolean) {
  page(id: $id, preview: $preview) {
    slug
  }
}
    `;
export const GetPagesDocument = gql`
    query getPages($where: PageFilter, $limit: Int, $skip: Int, $order: [PageOrder] = sys_publishedAt_DESC, $preview: Boolean = false) {
  pageCollection(
    where: $where
    preview: $preview
    limit: $limit
    skip: $skip
    order: $order
  ) {
    items {
      ...Page
    }
  }
}
    ${PageFragmentDoc}`;
export const GetPageIdBySlugDocument = gql`
    query getPageIdBySlug($slug: String!, $preview: Boolean = false) {
  pageCollection(where: { slug: $slug }, preview: $preview, limit: 1) {
    items {
      sys {
        id
      }
    }
  }
  programCollection(where: { slug: $slug }, preview: $preview, limit: 1) {
    items {
      sys {
        id
      }
    }
  }
  basicPageCollection(where: { slug: $slug }, preview: $preview, limit: 1) {
    items {
      sys {
        id
      }
    }
  }
}
    `;
export const GetPageSlugsDocument = gql`
    query getPageSlugs($limit: Int, $skip: Int, $where: PageFilter, $order: [PageOrder] = sys_publishedAt_DESC) {
  pageCollection(limit: $limit, skip: $skip, where: $where, order: $order) {
    total
    items {
      ...Entry
      title
      slug
    }
  }
}
    ${EntryFragmentDoc}`;
export const GetPartnerPageSlugsDocument = gql`
    query getPartnerPageSlugs($limit: Int, $skip: Int, $where: PartnerFilter, $order: [PartnerOrder] = sys_publishedAt_DESC) {
  partnerCollection(limit: $limit, skip: $skip, where: $where, order: $order) {
    total
    skip
    limit
    items {
      ...Entry
      title
      slug
    }
  }
}
    ${EntryFragmentDoc}`;
export const GetPartnerPagesDocument = gql`
    query getPartnerPages($where: PartnerFilter, $limit: Int, $skip: Int, $order: [PartnerOrder] = sys_publishedAt_DESC, $preview: Boolean = false) {
  partnerCollection(
    where: $where
    preview: $preview
    limit: $limit
    skip: $skip
    order: $order
  ) {
    items {
      ...PartnerPage
    }
  }
}
    ${PartnerPageFragmentDoc}`;
export const GetPartnerSlugByIdDocument = gql`
    query getPartnerSlugById($id: String!, $preview: Boolean) {
  partner(id: $id, preview: $preview) {
    slug
  }
}
    `;
export const GetPressReleasesDocument = gql`
    query getPressReleases($where: PressReleaseFilter, $limit: Int, $skip: Int, $order: [PressReleaseOrder] = date_DESC, $preview: Boolean = false) {
  pressReleases: pressReleaseCollection(
    skip: $skip
    limit: $limit
    preview: $preview
    where: $where
    order: $order
  ) {
    total
    skip
    limit
    items {
      ...PressReleaseTeaser
    }
  }
}
    ${PressReleaseTeaserFragmentDoc}`;
export const GetPressReleaseBySlugDocument = gql`
    query getPressReleaseBySlug($slug: String, $preview: Boolean) {
  pressReleaseCollection(where: { slug: $slug }, preview: $preview, limit: 1) {
    items {
      ...PressReleasePage
    }
  }
}
    ${PressReleasePageFragmentDoc}`;
export const GetPressReleaseSlugByIdDocument = gql`
    query getPressReleaseSlugById($id: String!, $preview: Boolean) {
  pressRelease(id: $id, preview: $preview) {
    slug
  }
}
    `;
export const GetPressReleaseSlugsDocument = gql`
    query getPressReleaseSlugs($limit: Int, $skip: Int) {
  pressReleaseCollection(limit: $limit, skip: $skip) {
    total
    items {
      ...Entry
      title
      slug
    }
  }
}
    ${EntryFragmentDoc}`;
export const GetProgramPageSlugsDocument = gql`
    query getProgramPageSlugs($limit: Int, $skip: Int, $where: ProgramFilter, $order: [ProgramOrder] = sys_publishedAt_DESC) {
  programCollection(where: $where, limit: $limit, skip: $skip, order: $order) {
    total
    items {
      ...Entry
      title
      slug
    }
  }
}
    ${EntryFragmentDoc}`;
export const GetProgramPageBySlugDocument = gql`
    query getProgramPageBySlug($slug: String, $preview: Boolean) {
  programCollection(where: { slug: $slug }, preview: $preview, limit: 1) {
    total
    skip
    limit
    items {
      ...ProgramPage
    }
  }
}
    ${ProgramPageFragmentDoc}`;
export const GetProgramSlugByIdDocument = gql`
    query getProgramSlugById($id: String!, $preview: Boolean) {
  program(id: $id, preview: $preview) {
    slug
  }
}
    `;
export const GetProgramsDocument = gql`
    query getPrograms($where: ProgramFilter, $limit: Int, $skip: Int, $order: [ProgramOrder] = sys_publishedAt_DESC, $preview: Boolean = false) {
  programCollection(
    where: $where
    preview: $preview
    limit: $limit
    skip: $skip
    order: $order
  ) {
    items {
      ...ProgramPage
    }
  }
}
    ${ProgramPageFragmentDoc}`;
export const GetRedirectsDocument = gql`
    query getRedirects {
  redirectCollection {
    items {
      source
      destination
    }
  }
}
    `;
export const GetRedirectBySourceDocument = gql`
    query getRedirectBySource($source: String!) {
  redirectCollection(where: { source: $source }) {
    items {
      source
      destination
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getBasicPageBySlug(variables?: GetBasicPageBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBasicPageBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBasicPageBySlugQuery>({ document: GetBasicPageBySlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBasicPageBySlug', 'query', variables);
    },
    getBasicPageSlugById(variables: GetBasicPageSlugByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBasicPageSlugByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBasicPageSlugByIdQuery>({ document: GetBasicPageSlugByIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBasicPageSlugById', 'query', variables);
    },
    getBasicPageSlugs(variables?: GetBasicPageSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBasicPageSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBasicPageSlugsQuery>({ document: GetBasicPageSlugsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBasicPageSlugs', 'query', variables);
    },
    getBlockBlogPosts(variables: GetBlockBlogPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockBlogPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockBlogPostsQuery>({ document: GetBlockBlogPostsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockBlogPosts', 'query', variables);
    },
    getBlockBulletinBoard(variables: GetBlockBulletinBoardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockBulletinBoardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockBulletinBoardQuery>({ document: GetBlockBulletinBoardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockBulletinBoard', 'query', variables);
    },
    getBlockBulletinBoardIdsByBulletinId(variables: GetBlockBulletinBoardIdsByBulletinIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockBulletinBoardIdsByBulletinIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockBulletinBoardIdsByBulletinIdQuery>({ document: GetBlockBulletinBoardIdsByBulletinIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockBulletinBoardIdsByBulletinId', 'query', variables);
    },
    getBlockClassy(variables: GetBlockClassyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockClassyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockClassyQuery>({ document: GetBlockClassyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockClassy', 'query', variables);
    },
    getBlockCollapsible(variables: GetBlockCollapsibleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockCollapsibleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockCollapsibleQuery>({ document: GetBlockCollapsibleDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockCollapsible', 'query', variables);
    },
    getBlockCopy(variables: GetBlockCopyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockCopyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockCopyQuery>({ document: GetBlockCopyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockCopy', 'query', variables);
    },
    getBlockCta(variables: GetBlockCtaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockCtaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockCtaQuery>({ document: GetBlockCtaDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockCta', 'query', variables);
    },
    getBlockCustomComponent(variables: GetBlockCustomComponentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockCustomComponentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockCustomComponentQuery>({ document: GetBlockCustomComponentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockCustomComponent', 'query', variables);
    },
    getBlockDonate(variables: GetBlockDonateQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockDonateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockDonateQuery>({ document: GetBlockDonateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockDonate', 'query', variables);
    },
    getBlockDonateIdsByDonationAppealId(variables: GetBlockDonateIdsByDonationAppealIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockDonateIdsByDonationAppealIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockDonateIdsByDonationAppealIdQuery>({ document: GetBlockDonateIdsByDonationAppealIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockDonateIdsByDonationAppealId', 'query', variables);
    },
    getBlockElfsightCalendar(variables: GetBlockElfsightCalendarQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockElfsightCalendarQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockElfsightCalendarQuery>({ document: GetBlockElfsightCalendarDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockElfsightCalendar', 'query', variables);
    },
    getBlockEmailCollection(variables: GetBlockEmailCollectionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockEmailCollectionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockEmailCollectionQuery>({ document: GetBlockEmailCollectionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockEmailCollection', 'query', variables);
    },
    getBlockFormAssembly(variables: GetBlockFormAssemblyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockFormAssemblyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockFormAssemblyQuery>({ document: GetBlockFormAssemblyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockFormAssembly', 'query', variables);
    },
    getBlockFundraiseUp(variables: GetBlockFundraiseUpQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockFundraiseUpQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockFundraiseUpQuery>({ document: GetBlockFundraiseUpDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockFundraiseUp', 'query', variables);
    },
    getBlockHero(variables: GetBlockHeroQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockHeroQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockHeroQuery>({ document: GetBlockHeroDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockHero', 'query', variables);
    },
    getBlockHighlight(variables: GetBlockHighlightQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockHighlightQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockHighlightQuery>({ document: GetBlockHighlightDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockHighlight', 'query', variables);
    },
    getBlockImages(variables: GetBlockImagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockImagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockImagesQuery>({ document: GetBlockImagesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockImages', 'query', variables);
    },
    getBlockStatistics(variables: GetBlockStatisticsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockStatisticsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockStatisticsQuery>({ document: GetBlockStatisticsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockStatistics', 'query', variables);
    },
    getBlockImpactStatisticIdsByStatisticId(variables: GetBlockImpactStatisticIdsByStatisticIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockImpactStatisticIdsByStatisticIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockImpactStatisticIdsByStatisticIdQuery>({ document: GetBlockImpactStatisticIdsByStatisticIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockImpactStatisticIdsByStatisticId', 'query', variables);
    },
    getBlockPartners(variables: GetBlockPartnersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockPartnersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockPartnersQuery>({ document: GetBlockPartnersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockPartners', 'query', variables);
    },
    getBlockPeople(variables: GetBlockPeopleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockPeopleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockPeopleQuery>({ document: GetBlockPeopleDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockPeople', 'query', variables);
    },
    getBlockPeopleIdsByPersonId(variables: GetBlockPeopleIdsByPersonIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockPeopleIdsByPersonIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockPeopleIdsByPersonIdQuery>({ document: GetBlockPeopleIdsByPersonIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockPeopleIdsByPersonId', 'query', variables);
    },
    getBlockPrograms(variables: GetBlockProgramsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockProgramsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockProgramsQuery>({ document: GetBlockProgramsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockPrograms', 'query', variables);
    },
    getBlockProgramIdsByProgramId(variables: GetBlockProgramIdsByProgramIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockProgramIdsByProgramIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockProgramIdsByProgramIdQuery>({ document: GetBlockProgramIdsByProgramIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockProgramIdsByProgramId', 'query', variables);
    },
    getBlockQuotation(variables: GetBlockQuotationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockQuotationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockQuotationQuery>({ document: GetBlockQuotationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockQuotation', 'query', variables);
    },
    getBlockQuotations(variables: GetBlockQuotationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockQuotationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockQuotationsQuery>({ document: GetBlockQuotationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockQuotations', 'query', variables);
    },
    getBlockShare(variables: GetBlockShareQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockShareQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockShareQuery>({ document: GetBlockShareDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockShare', 'query', variables);
    },
    getBlockTabs(variables: GetBlockTabsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockTabsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockTabsQuery>({ document: GetBlockTabsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockTabs', 'query', variables);
    },
    getBlockTabsIdsByTabId(variables: GetBlockTabsIdsByTabIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockTabsIdsByTabIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockTabsIdsByTabIdQuery>({ document: GetBlockTabsIdsByTabIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockTabsIdsByTabId', 'query', variables);
    },
    getBlockThermometer(variables: GetBlockThermometerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockThermometerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockThermometerQuery>({ document: GetBlockThermometerDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockThermometer', 'query', variables);
    },
    getBlockVideo(variables: GetBlockVideoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlockVideoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlockVideoQuery>({ document: GetBlockVideoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlockVideo', 'query', variables);
    },
    getBlogSlugs(variables?: GetBlogSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlogSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlogSlugsQuery>({ document: GetBlogSlugsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlogSlugs', 'query', variables);
    },
    getBlogPosts(variables?: GetBlogPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlogPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlogPostsQuery>({ document: GetBlogPostsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlogPosts', 'query', variables);
    },
    searchBlogPosts(variables?: SearchBlogPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SearchBlogPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchBlogPostsQuery>({ document: SearchBlogPostsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'searchBlogPosts', 'query', variables);
    },
    getBlogPostBySlug(variables?: GetBlogPostBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlogPostBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlogPostBySlugQuery>({ document: GetBlogPostBySlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlogPostBySlug', 'query', variables);
    },
    getBlogPostSlugById(variables: GetBlogPostSlugByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlogPostSlugByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlogPostSlugByIdQuery>({ document: GetBlogPostSlugByIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlogPostSlugById', 'query', variables);
    },
    getBlogPostSlugs(variables?: GetBlogPostSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetBlogPostSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBlogPostSlugsQuery>({ document: GetBlogPostSlugsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getBlogPostSlugs', 'query', variables);
    },
    getNavigation(variables: GetNavigationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetNavigationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetNavigationQuery>({ document: GetNavigationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getNavigation', 'query', variables);
    },
    getLandingPageSlugs(variables?: GetLandingPageSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetLandingPageSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLandingPageSlugsQuery>({ document: GetLandingPageSlugsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getLandingPageSlugs', 'query', variables);
    },
    getPageBySlug(variables?: GetPageBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPageBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageBySlugQuery>({ document: GetPageBySlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPageBySlug', 'query', variables);
    },
    getPageSlugById(variables: GetPageSlugByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPageSlugByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageSlugByIdQuery>({ document: GetPageSlugByIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPageSlugById', 'query', variables);
    },
    getPages(variables?: GetPagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPagesQuery>({ document: GetPagesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPages', 'query', variables);
    },
    getPageIdBySlug(variables: GetPageIdBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPageIdBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageIdBySlugQuery>({ document: GetPageIdBySlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPageIdBySlug', 'query', variables);
    },
    getPageSlugs(variables?: GetPageSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPageSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageSlugsQuery>({ document: GetPageSlugsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPageSlugs', 'query', variables);
    },
    getPartnerPageSlugs(variables?: GetPartnerPageSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPartnerPageSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPartnerPageSlugsQuery>({ document: GetPartnerPageSlugsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPartnerPageSlugs', 'query', variables);
    },
    getPartnerPages(variables?: GetPartnerPagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPartnerPagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPartnerPagesQuery>({ document: GetPartnerPagesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPartnerPages', 'query', variables);
    },
    getPartnerSlugById(variables: GetPartnerSlugByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPartnerSlugByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPartnerSlugByIdQuery>({ document: GetPartnerSlugByIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPartnerSlugById', 'query', variables);
    },
    getPressReleases(variables?: GetPressReleasesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPressReleasesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPressReleasesQuery>({ document: GetPressReleasesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPressReleases', 'query', variables);
    },
    getPressReleaseBySlug(variables?: GetPressReleaseBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPressReleaseBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPressReleaseBySlugQuery>({ document: GetPressReleaseBySlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPressReleaseBySlug', 'query', variables);
    },
    getPressReleaseSlugById(variables: GetPressReleaseSlugByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPressReleaseSlugByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPressReleaseSlugByIdQuery>({ document: GetPressReleaseSlugByIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPressReleaseSlugById', 'query', variables);
    },
    getPressReleaseSlugs(variables?: GetPressReleaseSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetPressReleaseSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPressReleaseSlugsQuery>({ document: GetPressReleaseSlugsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPressReleaseSlugs', 'query', variables);
    },
    getProgramPageSlugs(variables?: GetProgramPageSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetProgramPageSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProgramPageSlugsQuery>({ document: GetProgramPageSlugsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getProgramPageSlugs', 'query', variables);
    },
    getProgramPageBySlug(variables?: GetProgramPageBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetProgramPageBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProgramPageBySlugQuery>({ document: GetProgramPageBySlugDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getProgramPageBySlug', 'query', variables);
    },
    getProgramSlugById(variables: GetProgramSlugByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetProgramSlugByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProgramSlugByIdQuery>({ document: GetProgramSlugByIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getProgramSlugById', 'query', variables);
    },
    getPrograms(variables?: GetProgramsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetProgramsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProgramsQuery>({ document: GetProgramsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getPrograms', 'query', variables);
    },
    getRedirects(variables?: GetRedirectsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetRedirectsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRedirectsQuery>({ document: GetRedirectsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getRedirects', 'query', variables);
    },
    getRedirectBySource(variables: GetRedirectBySourceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetRedirectBySourceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRedirectBySourceQuery>({ document: GetRedirectBySourceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'getRedirectBySource', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;